// Fichier généré. Ne pas éditer à la main.

export const THEME = {
  light: {
    small: {
      brand: 'refrain',
      mode: 'light',
      breakpoint: 'small',
      colors: {
        black: '#1F2635',
        'border.brand': '#354973',
        'border.brand-alt': '#DFE0E6',
        'border.disabled': '#28272514',
        'border.divider': '#2827251F',
        'border.error': '#BE171B',
        'border.focused': '#4F7AC1',
        'border.info': '#2C6CBF',
        'border.interactive': '#719CD3',
        'border.inverse.disabled': '#FDFDFC66',
        'border.inverse.divider': '#FDFDFC33',
        'border.inverse.interactive': '#CBCDD6',
        'border.inverse.primary': '#FFFFFF',
        'border.inverse.secondary': '#FDFDFC66',
        'border.inverse.selected': '#CBCDD6',
        'border.inverse.strong': '#FFFFFF',
        'border.primary': '#28272566',
        'border.secondary': '#28272529',
        'border.secondary-1.default': '#CDF496',
        'border.secondary-1.strong': '#325017',
        'border.secondary-1.subtle': '#F6FDE8',
        'border.secondary-2.default': '#EDD441',
        'border.secondary-2.strong': '#6A4019',
        'border.secondary-2.subtle': '#FCFBEA',
        'border.secondary-3.default': '#FFAD54',
        'border.secondary-3.strong': '#7E3410',
        'border.secondary-3.subtle': '#FFF8ED',
        'border.secondary-4.default': '#FFA9AB',
        'border.secondary-4.strong': '#3E2D30',
        'border.secondary-4.subtle': '#FFF7F7',
        'border.secondary-5.default': '#A0A7FF',
        'border.secondary-5.low': '#C6CAFF',
        'border.secondary-5.medium': '#666AA0',
        'border.secondary-5.strong': '#2B2C41',
        'border.secondary-5.subtle': '#F6F7FF',
        'border.selected': '#719CD3',
        'border.strong': '#1F2635',
        'border.success': '#5B9D13',
        'border.warning': '#BB8713',
        'component.button.bg.hover': '#FDFDFC33',
        'component.button.bg.inverted': '#FFFFFF',
        'component.button.bg.pressed': '#28272566',
        'component.button.bg.primary': '#1F2635',
        'component.button.bg.secondary': '#DFE0E6',
        'component.button.bg.tertiary': '#F5F3F0',
        'component.button.bg.transparent': '#28272599',
        'component.button.border.tertiary': '#1F2635',
        'component.button.icon.tertiary': '#636271',
        'component.button.label.tertiary': '#1F2635',
        'concept.ambassador.border': '#F5EA93',
        'concept.ambassador.icon': '#BB8713',
        'concept.ambassador.surface.default': '#D8AD1A',
        'concept.ambassador.surface.strong': '#6A4019',
        'concept.ambassador.surface.subtle': '#FCFBEA',
        'concept.ambassador.text': '#956213',
        'concept.exoneration.border': '#DFE0E6',
        'concept.exoneration.icon': '#52525D',
        'concept.exoneration.surface.default': '#A0A0B4',
        'concept.exoneration.surface.low': '#EDEEF2',
        'concept.exoneration.surface.medium': '#7F7C90',
        'concept.exoneration.surface.strong': '#52525D',
        'concept.exoneration.surface.subtle': '#F5F6F8',
        'concept.exoneration.text': '#52525D',
        'concept.pension.border': '#ADCDF7',
        'concept.pension.icon': '#2C6CBF',
        'concept.pension.surface.default': '#3383EB',
        'concept.pension.surface.strong': '#15253D',
        'concept.pension.surface.subtle': '#EBF3FE',
        'concept.pension.text-on-dark': '#EBF3FE',
        'concept.pension.text-on-light': '#255594',
        'concept.plan.free.icon-on-surface': '#1F2635',
        'concept.plan.free.surface.default': '#3383EB',
        'concept.plan.free.surface.low': '#ADCDF7',
        'concept.plan.free.surface.medium': '#255594',
        'concept.plan.free.surface.strong': '#15253D',
        'concept.plan.free.surface.subtle': '#EBF3FE',
        'concept.plan.free.text-on-surface': '#1F2635',
        'concept.plan.premium.accent': '#F5EA93',
        'concept.plan.premium.border': '#D9DCFF',
        'concept.plan.premium.icon-on-surface': '#8388CF',
        'concept.plan.premium.surface.default': '#A0A7FF',
        'concept.plan.premium.surface.low': '#D9DCFF',
        'concept.plan.premium.surface.medium': '#666AA0',
        'concept.plan.premium.surface.strong': '#2B2C41',
        'concept.plan.premium.surface.subtle': '#F6F7FF',
        'concept.plan.premium.text-on-surface': '#666AA0',
        'concept.trust-club.border': '#FFDDDD',
        'concept.trust-club.icon': '#FFA9AB',
        'concept.trust-club.surface.default': '#FFA9AB',
        'concept.trust-club.surface.strong': '#3E2D30',
        'concept.trust-club.surface.subtle': '#FFF7F7',
        'concept.trust-club.text-on-dark': '#FFF7F7',
        'concept.trust-club.text-on-light': '#9F6B6E',
        'gradient.bottom-tab-bar-end': '#FEFEFDB2',
        'gradient.bottom-tab-bar-start': '#FEFEFD00',
        'gradient.primary': '#FFFFFF00',
        'icon.brand': '#52525D',
        'icon.brand-alt': '#DFE0E6',
        'icon.disabled': '#28272566',
        'icon.emphasized': '#8D8BA0',
        'icon.error': '#BE171B',
        'icon.info': '#2C6CBF',
        'icon.interactive': '#719CD3',
        'icon.inverse.disabled': '#FDFDFC99',
        'icon.inverse.interactive': '#CBCDD6',
        'icon.inverse.on-selected': '#A0A0B4',
        'icon.inverse.primary': '#FFFFFF',
        'icon.inverse.secondary': '#FDFDFC',
        'icon.primary': '#1F2635',
        'icon.secondary': '#6B6861',
        'icon.secondary-1.default': '#77C41E',
        'icon.secondary-1.low': '#CDF496',
        'icon.secondary-1.medium': '#457714',
        'icon.secondary-1.strong': '#325017',
        'icon.secondary-1.subtle': '#F6FDE8',
        'icon.secondary-2.default': '#E8C427',
        'icon.secondary-2.low': '#F5EA93',
        'icon.secondary-2.medium': '#BB8713',
        'icon.secondary-2.strong': '#6A4019',
        'icon.secondary-2.subtle': '#FCFBEA',
        'icon.secondary-3.default': '#FFAD54',
        'icon.secondary-3.low': '#FFDDA8',
        'icon.secondary-3.medium': '#EF6707',
        'icon.secondary-3.strong': '#7E3410',
        'icon.secondary-3.subtle': '#FFF8ED',
        'icon.secondary-4.default': '#FFA9AB',
        'icon.secondary-4.low': '#FFCBCD',
        'icon.secondary-4.medium': '#9F6B6E',
        'icon.secondary-4.strong': '#3E2D30',
        'icon.secondary-4.subtle': '#FFF7F7',
        'icon.secondary-5.default': '#A0A7FF',
        'icon.secondary-5.low': '#C6CAFF',
        'icon.secondary-5.medium': '#666AA0',
        'icon.secondary-5.strong': '#2B2C41',
        'icon.secondary-5.subtle': '#F6F7FF',
        'icon.selected': '#719CD3',
        'icon.success': '#457714',
        'icon.tertiary': '#C6C3B9',
        'icon.warning': '#BB8713',
        page: '#FFFFFF',
        'shadow.inner': '#FDFDFC66',
        'shadow.lg': '#28272529',
        'shadow.md': '#2827251F',
        'shadow.sm': '#28272514',
        'shadow.xl': '#28272533',
        'shadow.xs': '#2827250A',
        'state-layer.hover': '#28272514',
        'state-layer.hover-alt': '#28272514',
        'state-layer.hover-brand': '#7F7C9033',
        'state-layer.hover-on-color': '#28272533',
        'state-layer.inverse.hover': '#FDFDFC14',
        'state-layer.inverse.hover-brand': '#7F7C9033',
        'state-layer.inverse.hover-on-color': '#FDFDFC33',
        'state-layer.inverse.press': '#FDFDFC29',
        'state-layer.inverse.press-brand': '#7F7C9066',
        'state-layer.inverse.press-on-color': '#28272566',
        'state-layer.press': '#28272529',
        'state-layer.press-alt': '#28272529',
        'state-layer.press-brand': '#7F7C9066',
        'state-layer.press-on-color': '#28272566',
        'surface.brand.bold': '#303036',
        'surface.brand.bold-alt': '#242E47',
        'surface.brand.default': '#A0A0B4',
        'surface.brand.default-alt': '#719CD3',
        'surface.brand.secondary-1.default': '#77C41E',
        'surface.brand.secondary-1.low': '#B3EC6A',
        'surface.brand.secondary-1.medium': '#457714',
        'surface.brand.secondary-1.strong': '#325017',
        'surface.brand.secondary-1.subtle': '#E8FACD',
        'surface.brand.secondary-1.translucent.default': '#CDF49633',
        'surface.brand.secondary-1.translucent.low': '#CDF49629',
        'surface.brand.secondary-1.translucent.medium': '#CDF49666',
        'surface.brand.secondary-1.translucent.strong': '#CDF49699',
        'surface.brand.secondary-1.translucent.subtle': '#CDF4961F',
        'surface.brand.secondary-2.default': '#EDD441',
        'surface.brand.secondary-2.low': '#F5EA93',
        'surface.brand.secondary-2.medium': '#D8AD1A',
        'surface.brand.secondary-2.strong': '#6A4019',
        'surface.brand.secondary-2.subtle': '#F9F6C8',
        'surface.brand.secondary-2.translucent.default': '#EDD44133',
        'surface.brand.secondary-2.translucent.low': '#EDD44129',
        'surface.brand.secondary-2.translucent.medium': '#EDD44166',
        'surface.brand.secondary-2.translucent.strong': '#EDD44199',
        'surface.brand.secondary-2.translucent.subtle': '#EDD4411F',
        'surface.brand.secondary-3.default': '#FFAD54',
        'surface.brand.secondary-3.low': '#FFDDA8',
        'surface.brand.secondary-3.medium': '#EF6707',
        'surface.brand.secondary-3.strong': '#7E3410',
        'surface.brand.secondary-3.subtle': '#FFF0D4',
        'surface.brand.secondary-3.translucent.default': '#FFAD5433',
        'surface.brand.secondary-3.translucent.low': '#FFAD5429',
        'surface.brand.secondary-3.translucent.medium': '#FFAD5466',
        'surface.brand.secondary-3.translucent.strong': '#FFAD5499',
        'surface.brand.secondary-3.translucent.subtle': '#FFAD541F',
        'surface.brand.secondary-4.default': '#FFA9AB',
        'surface.brand.secondary-4.low': '#FFCBCD',
        'surface.brand.secondary-4.medium': '#9F6B6E',
        'surface.brand.secondary-4.strong': '#3E2D30',
        'surface.brand.secondary-4.subtle': '#FFEEEE',
        'surface.brand.secondary-4.translucent.default': '#FFA9AB33',
        'surface.brand.secondary-4.translucent.low': '#FFA9AB29',
        'surface.brand.secondary-4.translucent.medium': '#FFA9AB66',
        'surface.brand.secondary-4.translucent.strong': '#FFA9AB99',
        'surface.brand.secondary-4.translucent.subtle': '#FFA9AB1F',
        'surface.brand.secondary-5.default': '#A0A7FF',
        'surface.brand.secondary-5.low': '#C6CAFF',
        'surface.brand.secondary-5.medium': '#666AA0',
        'surface.brand.secondary-5.strong': '#2B2C41',
        'surface.brand.secondary-5.subtle': '#ECEDFF',
        'surface.brand.secondary-5.translucent.default': '#A0A7FF33',
        'surface.brand.secondary-5.translucent.low': '#A0A7FF29',
        'surface.brand.secondary-5.translucent.medium': '#A0A7FF66',
        'surface.brand.secondary-5.translucent.strong': '#A0A7FF99',
        'surface.brand.secondary-5.translucent.subtle': '#A0A7FF1F',
        'surface.brand.strong': '#52525D',
        'surface.brand.strong-alt': '#354973',
        'surface.brand.subtle': '#F5F6F8',
        'surface.brand.subtle-alt': '#F2F7FC',
        'surface.brand.translucent.bold': '#7F7C9066',
        'surface.brand.translucent.bold-alt': '#7F7C9066',
        'surface.brand.translucent.default': '#7F7C9033',
        'surface.brand.translucent.strong': '#7F7C9066',
        'surface.brand.translucent.strong-alt': '#7F7C9066',
        'surface.brand.translucent.subtle': '#7F7C9014',
        'surface.default': '#FFFFFF',
        'surface.disabled': '#2827251F',
        'surface.error.default': '#F53E42',
        'surface.error.low': '#FFA9AB',
        'surface.error.medium': '#BE171B',
        'surface.error.strong': '#470809',
        'surface.error.subtle': '#FFE1E2',
        'surface.error.translucent.default': '#F53E4266',
        'surface.error.translucent.strong': '#F53E4299',
        'surface.error.translucent.subtle': '#F53E4233',
        'surface.info.default': '#3383EB',
        'surface.info.low': '#85B5F3',
        'surface.info.medium': '#255594',
        'surface.info.strong': '#121A27',
        'surface.info.subtle': '#EBF3FE',
        'surface.info.translucent.default': '#3383EB66',
        'surface.info.translucent.strong': '#3383EB99',
        'surface.info.translucent.subtle': '#3383EB33',
        'surface.interactive': '#719CD3',
        'surface.inverse.default': '#1F2635',
        'surface.inverse.disabled': '#FDFDFC33',
        'surface.inverse.primary-neutral': '#9B988C',
        'surface.inverse.secondary-neutral': '#C6C3B9',
        'surface.inverse.selected': '#F2F7FC',
        'surface.inverse.selected-strong': '#FFFFFF',
        'surface.inverse.tertiary-neutral': '#EEECE7',
        'surface.overlay': '#28272566',
        'surface.primary': '#F5F6F8',
        'surface.primary-alt': '#F2F7FC',
        'surface.primary-neutral': '#F9F8F6',
        'surface.secondary': '#EDEEF2',
        'surface.secondary-alt': '#E2ECF7',
        'surface.secondary-neutral': '#F5F3F0',
        'surface.selected': '#F2F7FC',
        'surface.selected-strong': '#719CD3',
        'surface.strong-neutral': '#3E3B38',
        'surface.success.default': '#77C41E',
        'surface.success.low': '#B3EC6A',
        'surface.success.medium': '#457714',
        'surface.success.strong': '#182C07',
        'surface.success.subtle': '#E8FACD',
        'surface.success.translucent.default': '#77C41E66',
        'surface.success.translucent.strong': '#77C41E99',
        'surface.success.translucent.subtle': '#77C41E33',
        'surface.tertiary': '#DFE0E6',
        'surface.tertiary-alt': '#CCDEF1',
        'surface.tertiary-neutral': '#EEECE7',
        'surface.translucent.default': '#2827250A',
        'surface.translucent.disabled': '#2827251F',
        'surface.translucent.primary': '#7F7C9014',
        'surface.translucent.primary-alt': '#7F7C9014',
        'surface.translucent.primary-neutral': '#28272514',
        'surface.translucent.secondary': '#7F7C9029',
        'surface.translucent.secondary-alt': '#7F7C9029',
        'surface.translucent.secondary-neutral': '#28272529',
        'surface.translucent.selected': '#7F7C9029',
        'surface.translucent.strong-neutral': '#28272566',
        'surface.translucent.tertiary': '#7F7C9066',
        'surface.translucent.tertiary-alt': '#7F7C9033',
        'surface.translucent.tertiary-neutral': '#28272533',
        'surface.warning.default': '#D8AD1A',
        'surface.warning.low': '#EDD441',
        'surface.warning.medium': '#956213',
        'surface.warning.strong': '#3D220B',
        'surface.warning.subtle': '#F9F6C8',
        'surface.warning.translucent.default': '#D8AD1A66',
        'surface.warning.translucent.strong': '#D8AD1A99',
        'surface.warning.translucent.subtle': '#D8AD1A33',
        'text.brand': '#52525D',
        'text.brand-alt': '#DFE0E6',
        'text.disabled': '#28272566',
        'text.emphasized': '#4F7AC1',
        'text.error': '#BE171B',
        'text.info': '#2C6CBF',
        'text.interactive': '#4F7AC1',
        'text.inverse.disabled': '#FDFDFC66',
        'text.inverse.emphasized': '#E2ECF7',
        'text.inverse.interactive': '#CBCDD6',
        'text.inverse.primary': '#FFFFFF',
        'text.inverse.secondary': '#FDFDFCCC',
        'text.primary': '#1F2635',
        'text.secondary': '#6B6861',
        'text.secondary-1.default': '#77C41E',
        'text.secondary-1.low': '#B3EC6A',
        'text.secondary-1.medium': '#457714',
        'text.secondary-1.strong': '#325017',
        'text.secondary-1.subtle': '#F6FDE8',
        'text.secondary-2.default': '#EDD441',
        'text.secondary-2.low': '#F5EA93',
        'text.secondary-2.medium': '#D8AD1A',
        'text.secondary-2.strong': '#6A4019',
        'text.secondary-2.subtle': '#FCFBEA',
        'text.secondary-3.default': '#FFAD54',
        'text.secondary-3.low': '#FFDDA8',
        'text.secondary-3.medium': '#EF6707',
        'text.secondary-3.strong': '#7E3410',
        'text.secondary-3.subtle': '#FFF8ED',
        'text.secondary-4.default': '#FFA9AB',
        'text.secondary-4.low': '#FFCBCD',
        'text.secondary-4.medium': '#9F6B6E',
        'text.secondary-4.strong': '#3E2D30',
        'text.secondary-4.subtle': '#FFF7F7',
        'text.secondary-5.default': '#A0A7FF',
        'text.secondary-5.low': '#C6CAFF',
        'text.secondary-5.medium': '#666AA0',
        'text.secondary-5.strong': '#2B2C41',
        'text.secondary-5.subtle': '#F6F7FF',
        'text.selected': '#4F7AC1',
        'text.success': '#457714',
        'text.tertiary': '#C6C3B9',
        'text.warning': '#BB8713',
        white: '#FFFFFF',
        'white-label.footer.footer-bg': '#7F7C90',
        'white-label.header.bg': '#7F7C90',
        'white-label.header.on-header': '#FFFFFF',
        'white-label.headerSubtext': '#FFFFFF',
        'white-label.highlight': '#FFFFFF',
        'white-label.highlightText': '#FFFFFF',
        'white-label.notificationLogoBackground': '#FFFFFF',
        'white-label.publish-button.bg.header-bar': '#FFFFFF',
        'white-label.publish-button.bg.mobile-bottom-tab-bar': '#636271',
        'white-label.publish-button.icon.header-bar': '#1F2635',
        'white-label.publish-button.icon.mobile-bottom-tab-bar': '#FFFFFF',
        'white-label.publish-button.label.primary': '#1F2635',
        'white-label.splash': '#7F7C90',
        'white-label.theme.icon.on-brand-accent': '#1F2635',
        'white-label.theme.surface.accent': '#FFFFFF',
        'white-label.theme.surface.primary': '#7F7C90',
        'white-label.theme.text.on-brand-accent': '#1F2635',
      },
      responsive: {
        'border-width.bold': '4',
        'border-width.emphasized': '2',
        'border-width.standard': '1.5',
        'border-width.subtle': '1',
        'motion.distance.component-enter': '8',
        'motion.distance.feedback': '2',
        'motion.distance.overlay-enter': '12',
        'motion.distance.page-enter': '16',
        'motion.duration.component-transition': '[object Object]',
        'motion.duration.feedback': '[object Object]',
        'motion.duration.micro-transition': '[object Object]',
        'motion.duration.overlay-transition': '[object Object]',
        'motion.duration.page-transition': '[object Object]',
        'motion.duration.passive': '[object Object]',
        'motion.easing.continuous': '0,0,1,1',
        'motion.easing.emphasize': '0.05000000074505806,0.699999988079071,0.10000000149011612,1',
        'motion.easing.enter': '0,0,0,1',
        'motion.easing.exit': '0.4000000059604645,0,1,1',
        'motion.easing.move': '0.20000000298023224,0,0,1',
        'motion.scale.emphasize': '1.0199999809265137',
        'motion.scale.enter': '0.9599999785423279',
        'motion.scale.press': '0.9800000190734863',
        'motion.stagger.relaxed': '[object Object]',
        'motion.stagger.standard': '[object Object]',
        'motion.stagger.tight': '[object Object]',
        'radius.component.fields.input': '16',
        'radius.component.publish-button.button-radius': '8',
        'radius.full': '1000',
        'radius.lg': '16',
        'radius.md': '12',
        'radius.none': '0',
        'radius.sm': '8',
        'radius.xl': '24',
        'radius.xs': '4',
        'radius.xxl': '32',
        'radius.xxs': '2',
        'shadow.blur.lg': '16',
        'shadow.blur.md': '8',
        'shadow.blur.sm': '4',
        'shadow.blur.xl': '24',
        'shadow.blur.xs': '2',
        'shadow.offset-y.lg': '4',
        'shadow.offset-y.md': '2',
        'shadow.offset-y.sm': '1',
        'shadow.offset-y.xl': '8',
        'shadow.offset-y.xs': '1',
        'sizing.body.max-width': '767',
        'sizing.body.min-width': '320',
        'sizing.component.button.height.large': '56',
        'sizing.component.button.height.large-icn-button': '48',
        'sizing.component.button.height.medium': '40',
        'sizing.component.button.height.small': '32',
        'sizing.component.header.max-width': '767',
        'sizing.component.header.min-width': '320',
        'sizing.general.0': '0',
        'sizing.general.x0,25': '1',
        'sizing.general.x0,5': '2',
        'sizing.general.x1': '4',
        'sizing.general.x10': '40',
        'sizing.general.x100': '400',
        'sizing.general.x12': '48',
        'sizing.general.x120': '480',
        'sizing.general.x14': '56',
        'sizing.general.x140': '560',
        'sizing.general.x150': '600',
        'sizing.general.x16': '64',
        'sizing.general.x160': '640',
        'sizing.general.x18': '72',
        'sizing.general.x180': '720',
        'sizing.general.x2': '8',
        'sizing.general.x20': '80',
        'sizing.general.x200': '800',
        'sizing.general.x22': '88',
        'sizing.general.x24': '96',
        'sizing.general.x3': '12',
        'sizing.general.x30': '120',
        'sizing.general.x36': '144',
        'sizing.general.x4': '16',
        'sizing.general.x40': '160',
        'sizing.general.x5': '20',
        'sizing.general.x50': '200',
        'sizing.general.x6': '24',
        'sizing.general.x60': '240',
        'sizing.general.x7': '28',
        'sizing.general.x70': '280',
        'sizing.general.x8': '32',
        'sizing.general.x80': '320',
        'sizing.general.x90': '360',
        'sizing.icon.default': '24',
        'sizing.icon.lg': '32',
        'sizing.icon.s': '16',
        'sizing.icon.sm': '20',
        'sizing.icon.xl': '56',
        'sizing.icon.xs': '12',
        'spacing.general.0': '0',
        'spacing.general.x0,5': '2',
        'spacing.general.x1': '4',
        'spacing.general.x10': '40',
        'spacing.general.x12': '48',
        'spacing.general.x14': '56',
        'spacing.general.x16': '64',
        'spacing.general.x18': '72',
        'spacing.general.x2': '8',
        'spacing.general.x20': '80',
        'spacing.general.x22': '88',
        'spacing.general.x24': '96',
        'spacing.general.x3': '12',
        'spacing.general.x30': '120',
        'spacing.general.x36': '144',
        'spacing.general.x4': '16',
        'spacing.general.x5': '20',
        'spacing.general.x6': '24',
        'spacing.general.x7': '28',
        'spacing.general.x8': '32',
        'spacing.semantic.bottom-safe-zone': '36',
        'spacing.semantic.line-height-fix': '2',
        'spacing.semantic.page-margin': '16',
        'typography.font-size.body.base': '16',
        'typography.font-size.body.caption-base': '10',
        'typography.font-size.body.caption-large': '12',
        'typography.font-size.body.large': '18',
        'typography.font-size.body.small': '14',
        'typography.font-size.body.x-large': '20',
        'typography.font-size.body.x-small': '12',
        'typography.font-size.header.display-1': '48',
        'typography.font-size.header.display-2': '56',
        'typography.font-size.header.large': '40',
        'typography.font-size.header.medium': '28',
        'typography.font-size.header.small': '24',
        'typography.font-size.header.x-small': '20',
        'typography.font-size.link.link-base': '16',
        'typography.font-size.link.link-large': '20',
        'typography.font-size.link.link-small': '14',
        'typography.letter-spacing.body.base': '0',
        'typography.letter-spacing.body.caption': '0',
        'typography.letter-spacing.body.large': '0',
        'typography.letter-spacing.body.small': '0',
        'typography.letter-spacing.body.x-large': '0',
        'typography.letter-spacing.body.x-small': '0',
        'typography.letter-spacing.header.display-1': '0',
        'typography.letter-spacing.header.display-2': '0',
        'typography.letter-spacing.header.large': '0',
        'typography.letter-spacing.header.medium': '0',
        'typography.letter-spacing.header.small': '0',
        'typography.letter-spacing.header.x-small': '0',
      },
      styles: {
        header: {
          'display-2': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '56',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'display-1': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '48',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '40',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '40', letterSpacing: '0', lineHeight: 'normal' },
          },
          medium: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '28',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'medium-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '28', letterSpacing: '0', lineHeight: 'normal' },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '24',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '24', letterSpacing: '0', lineHeight: 'normal' },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '20', letterSpacing: '0', lineHeight: 'normal' },
          },
        },
        body: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontWeight: '700', fontSize: '18', letterSpacing: '0', lineHeight: '120%' },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontWeight: '400', fontSize: '14', letterSpacing: '0', lineHeight: '120%' },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        caption: {
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        paragraph: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        link: {
          'link-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
        },
      },
    },
    medium: {
      brand: 'refrain',
      mode: 'light',
      breakpoint: 'medium',
      colors: {
        black: '#1F2635',
        'border.brand': '#354973',
        'border.brand-alt': '#DFE0E6',
        'border.disabled': '#28272514',
        'border.divider': '#2827251F',
        'border.error': '#BE171B',
        'border.focused': '#4F7AC1',
        'border.info': '#2C6CBF',
        'border.interactive': '#719CD3',
        'border.inverse.disabled': '#FDFDFC66',
        'border.inverse.divider': '#FDFDFC33',
        'border.inverse.interactive': '#CBCDD6',
        'border.inverse.primary': '#FFFFFF',
        'border.inverse.secondary': '#FDFDFC66',
        'border.inverse.selected': '#CBCDD6',
        'border.inverse.strong': '#FFFFFF',
        'border.primary': '#28272566',
        'border.secondary': '#28272529',
        'border.secondary-1.default': '#CDF496',
        'border.secondary-1.strong': '#325017',
        'border.secondary-1.subtle': '#F6FDE8',
        'border.secondary-2.default': '#EDD441',
        'border.secondary-2.strong': '#6A4019',
        'border.secondary-2.subtle': '#FCFBEA',
        'border.secondary-3.default': '#FFAD54',
        'border.secondary-3.strong': '#7E3410',
        'border.secondary-3.subtle': '#FFF8ED',
        'border.secondary-4.default': '#FFA9AB',
        'border.secondary-4.strong': '#3E2D30',
        'border.secondary-4.subtle': '#FFF7F7',
        'border.secondary-5.default': '#A0A7FF',
        'border.secondary-5.low': '#C6CAFF',
        'border.secondary-5.medium': '#666AA0',
        'border.secondary-5.strong': '#2B2C41',
        'border.secondary-5.subtle': '#F6F7FF',
        'border.selected': '#719CD3',
        'border.strong': '#1F2635',
        'border.success': '#5B9D13',
        'border.warning': '#BB8713',
        'component.button.bg.hover': '#FDFDFC33',
        'component.button.bg.inverted': '#FFFFFF',
        'component.button.bg.pressed': '#28272566',
        'component.button.bg.primary': '#1F2635',
        'component.button.bg.secondary': '#DFE0E6',
        'component.button.bg.tertiary': '#F5F3F0',
        'component.button.bg.transparent': '#28272599',
        'component.button.border.tertiary': '#1F2635',
        'component.button.icon.tertiary': '#636271',
        'component.button.label.tertiary': '#1F2635',
        'concept.ambassador.border': '#F5EA93',
        'concept.ambassador.icon': '#BB8713',
        'concept.ambassador.surface.default': '#D8AD1A',
        'concept.ambassador.surface.strong': '#6A4019',
        'concept.ambassador.surface.subtle': '#FCFBEA',
        'concept.ambassador.text': '#956213',
        'concept.exoneration.border': '#DFE0E6',
        'concept.exoneration.icon': '#52525D',
        'concept.exoneration.surface.default': '#A0A0B4',
        'concept.exoneration.surface.low': '#EDEEF2',
        'concept.exoneration.surface.medium': '#7F7C90',
        'concept.exoneration.surface.strong': '#52525D',
        'concept.exoneration.surface.subtle': '#F5F6F8',
        'concept.exoneration.text': '#52525D',
        'concept.pension.border': '#ADCDF7',
        'concept.pension.icon': '#2C6CBF',
        'concept.pension.surface.default': '#3383EB',
        'concept.pension.surface.strong': '#15253D',
        'concept.pension.surface.subtle': '#EBF3FE',
        'concept.pension.text-on-dark': '#EBF3FE',
        'concept.pension.text-on-light': '#255594',
        'concept.plan.free.icon-on-surface': '#1F2635',
        'concept.plan.free.surface.default': '#3383EB',
        'concept.plan.free.surface.low': '#ADCDF7',
        'concept.plan.free.surface.medium': '#255594',
        'concept.plan.free.surface.strong': '#15253D',
        'concept.plan.free.surface.subtle': '#EBF3FE',
        'concept.plan.free.text-on-surface': '#1F2635',
        'concept.plan.premium.accent': '#F5EA93',
        'concept.plan.premium.border': '#D9DCFF',
        'concept.plan.premium.icon-on-surface': '#8388CF',
        'concept.plan.premium.surface.default': '#A0A7FF',
        'concept.plan.premium.surface.low': '#D9DCFF',
        'concept.plan.premium.surface.medium': '#666AA0',
        'concept.plan.premium.surface.strong': '#2B2C41',
        'concept.plan.premium.surface.subtle': '#F6F7FF',
        'concept.plan.premium.text-on-surface': '#666AA0',
        'concept.trust-club.border': '#FFDDDD',
        'concept.trust-club.icon': '#FFA9AB',
        'concept.trust-club.surface.default': '#FFA9AB',
        'concept.trust-club.surface.strong': '#3E2D30',
        'concept.trust-club.surface.subtle': '#FFF7F7',
        'concept.trust-club.text-on-dark': '#FFF7F7',
        'concept.trust-club.text-on-light': '#9F6B6E',
        'gradient.bottom-tab-bar-end': '#FEFEFDB2',
        'gradient.bottom-tab-bar-start': '#FEFEFD00',
        'gradient.primary': '#FFFFFF00',
        'icon.brand': '#52525D',
        'icon.brand-alt': '#DFE0E6',
        'icon.disabled': '#28272566',
        'icon.emphasized': '#8D8BA0',
        'icon.error': '#BE171B',
        'icon.info': '#2C6CBF',
        'icon.interactive': '#719CD3',
        'icon.inverse.disabled': '#FDFDFC99',
        'icon.inverse.interactive': '#CBCDD6',
        'icon.inverse.on-selected': '#A0A0B4',
        'icon.inverse.primary': '#FFFFFF',
        'icon.inverse.secondary': '#FDFDFC',
        'icon.primary': '#1F2635',
        'icon.secondary': '#6B6861',
        'icon.secondary-1.default': '#77C41E',
        'icon.secondary-1.low': '#CDF496',
        'icon.secondary-1.medium': '#457714',
        'icon.secondary-1.strong': '#325017',
        'icon.secondary-1.subtle': '#F6FDE8',
        'icon.secondary-2.default': '#E8C427',
        'icon.secondary-2.low': '#F5EA93',
        'icon.secondary-2.medium': '#BB8713',
        'icon.secondary-2.strong': '#6A4019',
        'icon.secondary-2.subtle': '#FCFBEA',
        'icon.secondary-3.default': '#FFAD54',
        'icon.secondary-3.low': '#FFDDA8',
        'icon.secondary-3.medium': '#EF6707',
        'icon.secondary-3.strong': '#7E3410',
        'icon.secondary-3.subtle': '#FFF8ED',
        'icon.secondary-4.default': '#FFA9AB',
        'icon.secondary-4.low': '#FFCBCD',
        'icon.secondary-4.medium': '#9F6B6E',
        'icon.secondary-4.strong': '#3E2D30',
        'icon.secondary-4.subtle': '#FFF7F7',
        'icon.secondary-5.default': '#A0A7FF',
        'icon.secondary-5.low': '#C6CAFF',
        'icon.secondary-5.medium': '#666AA0',
        'icon.secondary-5.strong': '#2B2C41',
        'icon.secondary-5.subtle': '#F6F7FF',
        'icon.selected': '#719CD3',
        'icon.success': '#457714',
        'icon.tertiary': '#C6C3B9',
        'icon.warning': '#BB8713',
        page: '#FFFFFF',
        'shadow.inner': '#FDFDFC66',
        'shadow.lg': '#28272529',
        'shadow.md': '#2827251F',
        'shadow.sm': '#28272514',
        'shadow.xl': '#28272533',
        'shadow.xs': '#2827250A',
        'state-layer.hover': '#28272514',
        'state-layer.hover-alt': '#28272514',
        'state-layer.hover-brand': '#7F7C9033',
        'state-layer.hover-on-color': '#28272533',
        'state-layer.inverse.hover': '#FDFDFC14',
        'state-layer.inverse.hover-brand': '#7F7C9033',
        'state-layer.inverse.hover-on-color': '#FDFDFC33',
        'state-layer.inverse.press': '#FDFDFC29',
        'state-layer.inverse.press-brand': '#7F7C9066',
        'state-layer.inverse.press-on-color': '#28272566',
        'state-layer.press': '#28272529',
        'state-layer.press-alt': '#28272529',
        'state-layer.press-brand': '#7F7C9066',
        'state-layer.press-on-color': '#28272566',
        'surface.brand.bold': '#303036',
        'surface.brand.bold-alt': '#242E47',
        'surface.brand.default': '#A0A0B4',
        'surface.brand.default-alt': '#719CD3',
        'surface.brand.secondary-1.default': '#77C41E',
        'surface.brand.secondary-1.low': '#B3EC6A',
        'surface.brand.secondary-1.medium': '#457714',
        'surface.brand.secondary-1.strong': '#325017',
        'surface.brand.secondary-1.subtle': '#E8FACD',
        'surface.brand.secondary-1.translucent.default': '#CDF49633',
        'surface.brand.secondary-1.translucent.low': '#CDF49629',
        'surface.brand.secondary-1.translucent.medium': '#CDF49666',
        'surface.brand.secondary-1.translucent.strong': '#CDF49699',
        'surface.brand.secondary-1.translucent.subtle': '#CDF4961F',
        'surface.brand.secondary-2.default': '#EDD441',
        'surface.brand.secondary-2.low': '#F5EA93',
        'surface.brand.secondary-2.medium': '#D8AD1A',
        'surface.brand.secondary-2.strong': '#6A4019',
        'surface.brand.secondary-2.subtle': '#F9F6C8',
        'surface.brand.secondary-2.translucent.default': '#EDD44133',
        'surface.brand.secondary-2.translucent.low': '#EDD44129',
        'surface.brand.secondary-2.translucent.medium': '#EDD44166',
        'surface.brand.secondary-2.translucent.strong': '#EDD44199',
        'surface.brand.secondary-2.translucent.subtle': '#EDD4411F',
        'surface.brand.secondary-3.default': '#FFAD54',
        'surface.brand.secondary-3.low': '#FFDDA8',
        'surface.brand.secondary-3.medium': '#EF6707',
        'surface.brand.secondary-3.strong': '#7E3410',
        'surface.brand.secondary-3.subtle': '#FFF0D4',
        'surface.brand.secondary-3.translucent.default': '#FFAD5433',
        'surface.brand.secondary-3.translucent.low': '#FFAD5429',
        'surface.brand.secondary-3.translucent.medium': '#FFAD5466',
        'surface.brand.secondary-3.translucent.strong': '#FFAD5499',
        'surface.brand.secondary-3.translucent.subtle': '#FFAD541F',
        'surface.brand.secondary-4.default': '#FFA9AB',
        'surface.brand.secondary-4.low': '#FFCBCD',
        'surface.brand.secondary-4.medium': '#9F6B6E',
        'surface.brand.secondary-4.strong': '#3E2D30',
        'surface.brand.secondary-4.subtle': '#FFEEEE',
        'surface.brand.secondary-4.translucent.default': '#FFA9AB33',
        'surface.brand.secondary-4.translucent.low': '#FFA9AB29',
        'surface.brand.secondary-4.translucent.medium': '#FFA9AB66',
        'surface.brand.secondary-4.translucent.strong': '#FFA9AB99',
        'surface.brand.secondary-4.translucent.subtle': '#FFA9AB1F',
        'surface.brand.secondary-5.default': '#A0A7FF',
        'surface.brand.secondary-5.low': '#C6CAFF',
        'surface.brand.secondary-5.medium': '#666AA0',
        'surface.brand.secondary-5.strong': '#2B2C41',
        'surface.brand.secondary-5.subtle': '#ECEDFF',
        'surface.brand.secondary-5.translucent.default': '#A0A7FF33',
        'surface.brand.secondary-5.translucent.low': '#A0A7FF29',
        'surface.brand.secondary-5.translucent.medium': '#A0A7FF66',
        'surface.brand.secondary-5.translucent.strong': '#A0A7FF99',
        'surface.brand.secondary-5.translucent.subtle': '#A0A7FF1F',
        'surface.brand.strong': '#52525D',
        'surface.brand.strong-alt': '#354973',
        'surface.brand.subtle': '#F5F6F8',
        'surface.brand.subtle-alt': '#F2F7FC',
        'surface.brand.translucent.bold': '#7F7C9066',
        'surface.brand.translucent.bold-alt': '#7F7C9066',
        'surface.brand.translucent.default': '#7F7C9033',
        'surface.brand.translucent.strong': '#7F7C9066',
        'surface.brand.translucent.strong-alt': '#7F7C9066',
        'surface.brand.translucent.subtle': '#7F7C9014',
        'surface.default': '#FFFFFF',
        'surface.disabled': '#2827251F',
        'surface.error.default': '#F53E42',
        'surface.error.low': '#FFA9AB',
        'surface.error.medium': '#BE171B',
        'surface.error.strong': '#470809',
        'surface.error.subtle': '#FFE1E2',
        'surface.error.translucent.default': '#F53E4266',
        'surface.error.translucent.strong': '#F53E4299',
        'surface.error.translucent.subtle': '#F53E4233',
        'surface.info.default': '#3383EB',
        'surface.info.low': '#85B5F3',
        'surface.info.medium': '#255594',
        'surface.info.strong': '#121A27',
        'surface.info.subtle': '#EBF3FE',
        'surface.info.translucent.default': '#3383EB66',
        'surface.info.translucent.strong': '#3383EB99',
        'surface.info.translucent.subtle': '#3383EB33',
        'surface.interactive': '#719CD3',
        'surface.inverse.default': '#1F2635',
        'surface.inverse.disabled': '#FDFDFC33',
        'surface.inverse.primary-neutral': '#9B988C',
        'surface.inverse.secondary-neutral': '#C6C3B9',
        'surface.inverse.selected': '#F2F7FC',
        'surface.inverse.selected-strong': '#FFFFFF',
        'surface.inverse.tertiary-neutral': '#EEECE7',
        'surface.overlay': '#28272566',
        'surface.primary': '#F5F6F8',
        'surface.primary-alt': '#F2F7FC',
        'surface.primary-neutral': '#F9F8F6',
        'surface.secondary': '#EDEEF2',
        'surface.secondary-alt': '#E2ECF7',
        'surface.secondary-neutral': '#F5F3F0',
        'surface.selected': '#F2F7FC',
        'surface.selected-strong': '#719CD3',
        'surface.strong-neutral': '#3E3B38',
        'surface.success.default': '#77C41E',
        'surface.success.low': '#B3EC6A',
        'surface.success.medium': '#457714',
        'surface.success.strong': '#182C07',
        'surface.success.subtle': '#E8FACD',
        'surface.success.translucent.default': '#77C41E66',
        'surface.success.translucent.strong': '#77C41E99',
        'surface.success.translucent.subtle': '#77C41E33',
        'surface.tertiary': '#DFE0E6',
        'surface.tertiary-alt': '#CCDEF1',
        'surface.tertiary-neutral': '#EEECE7',
        'surface.translucent.default': '#2827250A',
        'surface.translucent.disabled': '#2827251F',
        'surface.translucent.primary': '#7F7C9014',
        'surface.translucent.primary-alt': '#7F7C9014',
        'surface.translucent.primary-neutral': '#28272514',
        'surface.translucent.secondary': '#7F7C9029',
        'surface.translucent.secondary-alt': '#7F7C9029',
        'surface.translucent.secondary-neutral': '#28272529',
        'surface.translucent.selected': '#7F7C9029',
        'surface.translucent.strong-neutral': '#28272566',
        'surface.translucent.tertiary': '#7F7C9066',
        'surface.translucent.tertiary-alt': '#7F7C9033',
        'surface.translucent.tertiary-neutral': '#28272533',
        'surface.warning.default': '#D8AD1A',
        'surface.warning.low': '#EDD441',
        'surface.warning.medium': '#956213',
        'surface.warning.strong': '#3D220B',
        'surface.warning.subtle': '#F9F6C8',
        'surface.warning.translucent.default': '#D8AD1A66',
        'surface.warning.translucent.strong': '#D8AD1A99',
        'surface.warning.translucent.subtle': '#D8AD1A33',
        'text.brand': '#52525D',
        'text.brand-alt': '#DFE0E6',
        'text.disabled': '#28272566',
        'text.emphasized': '#4F7AC1',
        'text.error': '#BE171B',
        'text.info': '#2C6CBF',
        'text.interactive': '#4F7AC1',
        'text.inverse.disabled': '#FDFDFC66',
        'text.inverse.emphasized': '#E2ECF7',
        'text.inverse.interactive': '#CBCDD6',
        'text.inverse.primary': '#FFFFFF',
        'text.inverse.secondary': '#FDFDFCCC',
        'text.primary': '#1F2635',
        'text.secondary': '#6B6861',
        'text.secondary-1.default': '#77C41E',
        'text.secondary-1.low': '#B3EC6A',
        'text.secondary-1.medium': '#457714',
        'text.secondary-1.strong': '#325017',
        'text.secondary-1.subtle': '#F6FDE8',
        'text.secondary-2.default': '#EDD441',
        'text.secondary-2.low': '#F5EA93',
        'text.secondary-2.medium': '#D8AD1A',
        'text.secondary-2.strong': '#6A4019',
        'text.secondary-2.subtle': '#FCFBEA',
        'text.secondary-3.default': '#FFAD54',
        'text.secondary-3.low': '#FFDDA8',
        'text.secondary-3.medium': '#EF6707',
        'text.secondary-3.strong': '#7E3410',
        'text.secondary-3.subtle': '#FFF8ED',
        'text.secondary-4.default': '#FFA9AB',
        'text.secondary-4.low': '#FFCBCD',
        'text.secondary-4.medium': '#9F6B6E',
        'text.secondary-4.strong': '#3E2D30',
        'text.secondary-4.subtle': '#FFF7F7',
        'text.secondary-5.default': '#A0A7FF',
        'text.secondary-5.low': '#C6CAFF',
        'text.secondary-5.medium': '#666AA0',
        'text.secondary-5.strong': '#2B2C41',
        'text.secondary-5.subtle': '#F6F7FF',
        'text.selected': '#4F7AC1',
        'text.success': '#457714',
        'text.tertiary': '#C6C3B9',
        'text.warning': '#BB8713',
        white: '#FFFFFF',
        'white-label.footer.footer-bg': '#7F7C90',
        'white-label.header.bg': '#7F7C90',
        'white-label.header.on-header': '#FFFFFF',
        'white-label.headerSubtext': '#FFFFFF',
        'white-label.highlight': '#FFFFFF',
        'white-label.highlightText': '#FFFFFF',
        'white-label.notificationLogoBackground': '#FFFFFF',
        'white-label.publish-button.bg.header-bar': '#FFFFFF',
        'white-label.publish-button.bg.mobile-bottom-tab-bar': '#636271',
        'white-label.publish-button.icon.header-bar': '#1F2635',
        'white-label.publish-button.icon.mobile-bottom-tab-bar': '#FFFFFF',
        'white-label.publish-button.label.primary': '#1F2635',
        'white-label.splash': '#7F7C90',
        'white-label.theme.icon.on-brand-accent': '#1F2635',
        'white-label.theme.surface.accent': '#FFFFFF',
        'white-label.theme.surface.primary': '#7F7C90',
        'white-label.theme.text.on-brand-accent': '#1F2635',
      },
      responsive: {
        'border-width.bold': '4',
        'border-width.emphasized': '2',
        'border-width.standard': '1.5',
        'border-width.subtle': '1',
        'motion.distance.component-enter': '8',
        'motion.distance.feedback': '2',
        'motion.distance.overlay-enter': '16',
        'motion.distance.page-enter': '24',
        'motion.duration.component-transition': '[object Object]',
        'motion.duration.feedback': '[object Object]',
        'motion.duration.micro-transition': '[object Object]',
        'motion.duration.overlay-transition': '[object Object]',
        'motion.duration.page-transition': '[object Object]',
        'motion.duration.passive': '[object Object]',
        'motion.easing.continuous': '0,0,1,1',
        'motion.easing.emphasize': '0.05000000074505806,0.699999988079071,0.10000000149011612,1',
        'motion.easing.enter': '0,0,0,1',
        'motion.easing.exit': '0.4000000059604645,0,1,1',
        'motion.easing.move': '0.20000000298023224,0,0,1',
        'motion.scale.emphasize': '1.0199999809265137',
        'motion.scale.enter': '0.9599999785423279',
        'motion.scale.press': '0.9800000190734863',
        'motion.stagger.relaxed': '[object Object]',
        'motion.stagger.standard': '[object Object]',
        'motion.stagger.tight': '[object Object]',
        'radius.component.fields.input': '16',
        'radius.component.publish-button.button-radius': '8',
        'radius.full': '1000',
        'radius.lg': '16',
        'radius.md': '12',
        'radius.none': '0',
        'radius.sm': '8',
        'radius.xl': '24',
        'radius.xs': '4',
        'radius.xxl': '32',
        'radius.xxs': '2',
        'shadow.blur.lg': '24',
        'shadow.blur.md': '12',
        'shadow.blur.sm': '8',
        'shadow.blur.xl': '36',
        'shadow.blur.xs': '2',
        'shadow.offset-y.lg': '8',
        'shadow.offset-y.md': '4',
        'shadow.offset-y.sm': '2',
        'shadow.offset-y.xl': '16',
        'shadow.offset-y.xs': '1',
        'sizing.body.max-width': '1279',
        'sizing.body.min-width': '768',
        'sizing.component.button.height.large': '56',
        'sizing.component.button.height.large-icn-button': '48',
        'sizing.component.button.height.medium': '40',
        'sizing.component.button.height.small': '32',
        'sizing.component.header.max-width': '1279',
        'sizing.component.header.min-width': '768',
        'sizing.general.0': '0',
        'sizing.general.x0,25': '1',
        'sizing.general.x0,5': '2',
        'sizing.general.x1': '4',
        'sizing.general.x10': '40',
        'sizing.general.x100': '400',
        'sizing.general.x12': '48',
        'sizing.general.x120': '480',
        'sizing.general.x14': '56',
        'sizing.general.x140': '560',
        'sizing.general.x150': '600',
        'sizing.general.x16': '64',
        'sizing.general.x160': '640',
        'sizing.general.x18': '72',
        'sizing.general.x180': '720',
        'sizing.general.x2': '8',
        'sizing.general.x20': '80',
        'sizing.general.x200': '800',
        'sizing.general.x22': '88',
        'sizing.general.x24': '96',
        'sizing.general.x3': '12',
        'sizing.general.x30': '120',
        'sizing.general.x36': '144',
        'sizing.general.x4': '16',
        'sizing.general.x40': '160',
        'sizing.general.x5': '20',
        'sizing.general.x50': '200',
        'sizing.general.x6': '24',
        'sizing.general.x60': '240',
        'sizing.general.x7': '28',
        'sizing.general.x70': '280',
        'sizing.general.x8': '32',
        'sizing.general.x80': '320',
        'sizing.general.x90': '360',
        'sizing.icon.default': '24',
        'sizing.icon.lg': '32',
        'sizing.icon.s': '16',
        'sizing.icon.sm': '20',
        'sizing.icon.xl': '56',
        'sizing.icon.xs': '12',
        'spacing.general.0': '0',
        'spacing.general.x0,5': '2',
        'spacing.general.x1': '4',
        'spacing.general.x10': '40',
        'spacing.general.x12': '48',
        'spacing.general.x14': '56',
        'spacing.general.x16': '64',
        'spacing.general.x18': '72',
        'spacing.general.x2': '8',
        'spacing.general.x20': '80',
        'spacing.general.x22': '88',
        'spacing.general.x24': '96',
        'spacing.general.x3': '12',
        'spacing.general.x30': '120',
        'spacing.general.x36': '144',
        'spacing.general.x4': '16',
        'spacing.general.x5': '20',
        'spacing.general.x6': '24',
        'spacing.general.x7': '28',
        'spacing.general.x8': '32',
        'spacing.semantic.bottom-safe-zone': '36',
        'spacing.semantic.line-height-fix': '2',
        'spacing.semantic.page-margin': '32',
        'typography.font-size.body.base': '16',
        'typography.font-size.body.caption-base': '10',
        'typography.font-size.body.caption-large': '12',
        'typography.font-size.body.large': '18',
        'typography.font-size.body.small': '14',
        'typography.font-size.body.x-large': '20',
        'typography.font-size.body.x-small': '12',
        'typography.font-size.header.display-1': '48',
        'typography.font-size.header.display-2': '56',
        'typography.font-size.header.large': '40',
        'typography.font-size.header.medium': '32',
        'typography.font-size.header.small': '28',
        'typography.font-size.header.x-small': '24',
        'typography.font-size.link.link-base': '16',
        'typography.font-size.link.link-large': '20',
        'typography.font-size.link.link-small': '14',
        'typography.letter-spacing.body.base': '0',
        'typography.letter-spacing.body.caption': '0',
        'typography.letter-spacing.body.large': '0',
        'typography.letter-spacing.body.small': '0',
        'typography.letter-spacing.body.x-large': '0',
        'typography.letter-spacing.body.x-small': '0',
        'typography.letter-spacing.header.display-1': '0',
        'typography.letter-spacing.header.display-2': '0',
        'typography.letter-spacing.header.large': '0',
        'typography.letter-spacing.header.medium': '0',
        'typography.letter-spacing.header.small': '0',
        'typography.letter-spacing.header.x-small': '0',
      },
      styles: {
        header: {
          'display-2': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '56',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'display-1': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '48',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '40',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '40', letterSpacing: '0', lineHeight: 'normal' },
          },
          medium: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '32',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'medium-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '32', letterSpacing: '0', lineHeight: 'normal' },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '28',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '28', letterSpacing: '0', lineHeight: 'normal' },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '24',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '24', letterSpacing: '0', lineHeight: 'normal' },
          },
        },
        body: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontWeight: '700', fontSize: '18', letterSpacing: '0', lineHeight: '120%' },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontWeight: '400', fontSize: '14', letterSpacing: '0', lineHeight: '120%' },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        caption: {
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        paragraph: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        link: {
          'link-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
        },
      },
    },
    large: {
      brand: 'refrain',
      mode: 'light',
      breakpoint: 'large',
      colors: {
        black: '#1F2635',
        'border.brand': '#354973',
        'border.brand-alt': '#DFE0E6',
        'border.disabled': '#28272514',
        'border.divider': '#2827251F',
        'border.error': '#BE171B',
        'border.focused': '#4F7AC1',
        'border.info': '#2C6CBF',
        'border.interactive': '#719CD3',
        'border.inverse.disabled': '#FDFDFC66',
        'border.inverse.divider': '#FDFDFC33',
        'border.inverse.interactive': '#CBCDD6',
        'border.inverse.primary': '#FFFFFF',
        'border.inverse.secondary': '#FDFDFC66',
        'border.inverse.selected': '#CBCDD6',
        'border.inverse.strong': '#FFFFFF',
        'border.primary': '#28272566',
        'border.secondary': '#28272529',
        'border.secondary-1.default': '#CDF496',
        'border.secondary-1.strong': '#325017',
        'border.secondary-1.subtle': '#F6FDE8',
        'border.secondary-2.default': '#EDD441',
        'border.secondary-2.strong': '#6A4019',
        'border.secondary-2.subtle': '#FCFBEA',
        'border.secondary-3.default': '#FFAD54',
        'border.secondary-3.strong': '#7E3410',
        'border.secondary-3.subtle': '#FFF8ED',
        'border.secondary-4.default': '#FFA9AB',
        'border.secondary-4.strong': '#3E2D30',
        'border.secondary-4.subtle': '#FFF7F7',
        'border.secondary-5.default': '#A0A7FF',
        'border.secondary-5.low': '#C6CAFF',
        'border.secondary-5.medium': '#666AA0',
        'border.secondary-5.strong': '#2B2C41',
        'border.secondary-5.subtle': '#F6F7FF',
        'border.selected': '#719CD3',
        'border.strong': '#1F2635',
        'border.success': '#5B9D13',
        'border.warning': '#BB8713',
        'component.button.bg.hover': '#FDFDFC33',
        'component.button.bg.inverted': '#FFFFFF',
        'component.button.bg.pressed': '#28272566',
        'component.button.bg.primary': '#1F2635',
        'component.button.bg.secondary': '#DFE0E6',
        'component.button.bg.tertiary': '#F5F3F0',
        'component.button.bg.transparent': '#28272599',
        'component.button.border.tertiary': '#1F2635',
        'component.button.icon.tertiary': '#636271',
        'component.button.label.tertiary': '#1F2635',
        'concept.ambassador.border': '#F5EA93',
        'concept.ambassador.icon': '#BB8713',
        'concept.ambassador.surface.default': '#D8AD1A',
        'concept.ambassador.surface.strong': '#6A4019',
        'concept.ambassador.surface.subtle': '#FCFBEA',
        'concept.ambassador.text': '#956213',
        'concept.exoneration.border': '#DFE0E6',
        'concept.exoneration.icon': '#52525D',
        'concept.exoneration.surface.default': '#A0A0B4',
        'concept.exoneration.surface.low': '#EDEEF2',
        'concept.exoneration.surface.medium': '#7F7C90',
        'concept.exoneration.surface.strong': '#52525D',
        'concept.exoneration.surface.subtle': '#F5F6F8',
        'concept.exoneration.text': '#52525D',
        'concept.pension.border': '#ADCDF7',
        'concept.pension.icon': '#2C6CBF',
        'concept.pension.surface.default': '#3383EB',
        'concept.pension.surface.strong': '#15253D',
        'concept.pension.surface.subtle': '#EBF3FE',
        'concept.pension.text-on-dark': '#EBF3FE',
        'concept.pension.text-on-light': '#255594',
        'concept.plan.free.icon-on-surface': '#1F2635',
        'concept.plan.free.surface.default': '#3383EB',
        'concept.plan.free.surface.low': '#ADCDF7',
        'concept.plan.free.surface.medium': '#255594',
        'concept.plan.free.surface.strong': '#15253D',
        'concept.plan.free.surface.subtle': '#EBF3FE',
        'concept.plan.free.text-on-surface': '#1F2635',
        'concept.plan.premium.accent': '#F5EA93',
        'concept.plan.premium.border': '#D9DCFF',
        'concept.plan.premium.icon-on-surface': '#8388CF',
        'concept.plan.premium.surface.default': '#A0A7FF',
        'concept.plan.premium.surface.low': '#D9DCFF',
        'concept.plan.premium.surface.medium': '#666AA0',
        'concept.plan.premium.surface.strong': '#2B2C41',
        'concept.plan.premium.surface.subtle': '#F6F7FF',
        'concept.plan.premium.text-on-surface': '#666AA0',
        'concept.trust-club.border': '#FFDDDD',
        'concept.trust-club.icon': '#FFA9AB',
        'concept.trust-club.surface.default': '#FFA9AB',
        'concept.trust-club.surface.strong': '#3E2D30',
        'concept.trust-club.surface.subtle': '#FFF7F7',
        'concept.trust-club.text-on-dark': '#FFF7F7',
        'concept.trust-club.text-on-light': '#9F6B6E',
        'gradient.bottom-tab-bar-end': '#FEFEFDB2',
        'gradient.bottom-tab-bar-start': '#FEFEFD00',
        'gradient.primary': '#FFFFFF00',
        'icon.brand': '#52525D',
        'icon.brand-alt': '#DFE0E6',
        'icon.disabled': '#28272566',
        'icon.emphasized': '#8D8BA0',
        'icon.error': '#BE171B',
        'icon.info': '#2C6CBF',
        'icon.interactive': '#719CD3',
        'icon.inverse.disabled': '#FDFDFC99',
        'icon.inverse.interactive': '#CBCDD6',
        'icon.inverse.on-selected': '#A0A0B4',
        'icon.inverse.primary': '#FFFFFF',
        'icon.inverse.secondary': '#FDFDFC',
        'icon.primary': '#1F2635',
        'icon.secondary': '#6B6861',
        'icon.secondary-1.default': '#77C41E',
        'icon.secondary-1.low': '#CDF496',
        'icon.secondary-1.medium': '#457714',
        'icon.secondary-1.strong': '#325017',
        'icon.secondary-1.subtle': '#F6FDE8',
        'icon.secondary-2.default': '#E8C427',
        'icon.secondary-2.low': '#F5EA93',
        'icon.secondary-2.medium': '#BB8713',
        'icon.secondary-2.strong': '#6A4019',
        'icon.secondary-2.subtle': '#FCFBEA',
        'icon.secondary-3.default': '#FFAD54',
        'icon.secondary-3.low': '#FFDDA8',
        'icon.secondary-3.medium': '#EF6707',
        'icon.secondary-3.strong': '#7E3410',
        'icon.secondary-3.subtle': '#FFF8ED',
        'icon.secondary-4.default': '#FFA9AB',
        'icon.secondary-4.low': '#FFCBCD',
        'icon.secondary-4.medium': '#9F6B6E',
        'icon.secondary-4.strong': '#3E2D30',
        'icon.secondary-4.subtle': '#FFF7F7',
        'icon.secondary-5.default': '#A0A7FF',
        'icon.secondary-5.low': '#C6CAFF',
        'icon.secondary-5.medium': '#666AA0',
        'icon.secondary-5.strong': '#2B2C41',
        'icon.secondary-5.subtle': '#F6F7FF',
        'icon.selected': '#719CD3',
        'icon.success': '#457714',
        'icon.tertiary': '#C6C3B9',
        'icon.warning': '#BB8713',
        page: '#FFFFFF',
        'shadow.inner': '#FDFDFC66',
        'shadow.lg': '#28272529',
        'shadow.md': '#2827251F',
        'shadow.sm': '#28272514',
        'shadow.xl': '#28272533',
        'shadow.xs': '#2827250A',
        'state-layer.hover': '#28272514',
        'state-layer.hover-alt': '#28272514',
        'state-layer.hover-brand': '#7F7C9033',
        'state-layer.hover-on-color': '#28272533',
        'state-layer.inverse.hover': '#FDFDFC14',
        'state-layer.inverse.hover-brand': '#7F7C9033',
        'state-layer.inverse.hover-on-color': '#FDFDFC33',
        'state-layer.inverse.press': '#FDFDFC29',
        'state-layer.inverse.press-brand': '#7F7C9066',
        'state-layer.inverse.press-on-color': '#28272566',
        'state-layer.press': '#28272529',
        'state-layer.press-alt': '#28272529',
        'state-layer.press-brand': '#7F7C9066',
        'state-layer.press-on-color': '#28272566',
        'surface.brand.bold': '#303036',
        'surface.brand.bold-alt': '#242E47',
        'surface.brand.default': '#A0A0B4',
        'surface.brand.default-alt': '#719CD3',
        'surface.brand.secondary-1.default': '#77C41E',
        'surface.brand.secondary-1.low': '#B3EC6A',
        'surface.brand.secondary-1.medium': '#457714',
        'surface.brand.secondary-1.strong': '#325017',
        'surface.brand.secondary-1.subtle': '#E8FACD',
        'surface.brand.secondary-1.translucent.default': '#CDF49633',
        'surface.brand.secondary-1.translucent.low': '#CDF49629',
        'surface.brand.secondary-1.translucent.medium': '#CDF49666',
        'surface.brand.secondary-1.translucent.strong': '#CDF49699',
        'surface.brand.secondary-1.translucent.subtle': '#CDF4961F',
        'surface.brand.secondary-2.default': '#EDD441',
        'surface.brand.secondary-2.low': '#F5EA93',
        'surface.brand.secondary-2.medium': '#D8AD1A',
        'surface.brand.secondary-2.strong': '#6A4019',
        'surface.brand.secondary-2.subtle': '#F9F6C8',
        'surface.brand.secondary-2.translucent.default': '#EDD44133',
        'surface.brand.secondary-2.translucent.low': '#EDD44129',
        'surface.brand.secondary-2.translucent.medium': '#EDD44166',
        'surface.brand.secondary-2.translucent.strong': '#EDD44199',
        'surface.brand.secondary-2.translucent.subtle': '#EDD4411F',
        'surface.brand.secondary-3.default': '#FFAD54',
        'surface.brand.secondary-3.low': '#FFDDA8',
        'surface.brand.secondary-3.medium': '#EF6707',
        'surface.brand.secondary-3.strong': '#7E3410',
        'surface.brand.secondary-3.subtle': '#FFF0D4',
        'surface.brand.secondary-3.translucent.default': '#FFAD5433',
        'surface.brand.secondary-3.translucent.low': '#FFAD5429',
        'surface.brand.secondary-3.translucent.medium': '#FFAD5466',
        'surface.brand.secondary-3.translucent.strong': '#FFAD5499',
        'surface.brand.secondary-3.translucent.subtle': '#FFAD541F',
        'surface.brand.secondary-4.default': '#FFA9AB',
        'surface.brand.secondary-4.low': '#FFCBCD',
        'surface.brand.secondary-4.medium': '#9F6B6E',
        'surface.brand.secondary-4.strong': '#3E2D30',
        'surface.brand.secondary-4.subtle': '#FFEEEE',
        'surface.brand.secondary-4.translucent.default': '#FFA9AB33',
        'surface.brand.secondary-4.translucent.low': '#FFA9AB29',
        'surface.brand.secondary-4.translucent.medium': '#FFA9AB66',
        'surface.brand.secondary-4.translucent.strong': '#FFA9AB99',
        'surface.brand.secondary-4.translucent.subtle': '#FFA9AB1F',
        'surface.brand.secondary-5.default': '#A0A7FF',
        'surface.brand.secondary-5.low': '#C6CAFF',
        'surface.brand.secondary-5.medium': '#666AA0',
        'surface.brand.secondary-5.strong': '#2B2C41',
        'surface.brand.secondary-5.subtle': '#ECEDFF',
        'surface.brand.secondary-5.translucent.default': '#A0A7FF33',
        'surface.brand.secondary-5.translucent.low': '#A0A7FF29',
        'surface.brand.secondary-5.translucent.medium': '#A0A7FF66',
        'surface.brand.secondary-5.translucent.strong': '#A0A7FF99',
        'surface.brand.secondary-5.translucent.subtle': '#A0A7FF1F',
        'surface.brand.strong': '#52525D',
        'surface.brand.strong-alt': '#354973',
        'surface.brand.subtle': '#F5F6F8',
        'surface.brand.subtle-alt': '#F2F7FC',
        'surface.brand.translucent.bold': '#7F7C9066',
        'surface.brand.translucent.bold-alt': '#7F7C9066',
        'surface.brand.translucent.default': '#7F7C9033',
        'surface.brand.translucent.strong': '#7F7C9066',
        'surface.brand.translucent.strong-alt': '#7F7C9066',
        'surface.brand.translucent.subtle': '#7F7C9014',
        'surface.default': '#FFFFFF',
        'surface.disabled': '#2827251F',
        'surface.error.default': '#F53E42',
        'surface.error.low': '#FFA9AB',
        'surface.error.medium': '#BE171B',
        'surface.error.strong': '#470809',
        'surface.error.subtle': '#FFE1E2',
        'surface.error.translucent.default': '#F53E4266',
        'surface.error.translucent.strong': '#F53E4299',
        'surface.error.translucent.subtle': '#F53E4233',
        'surface.info.default': '#3383EB',
        'surface.info.low': '#85B5F3',
        'surface.info.medium': '#255594',
        'surface.info.strong': '#121A27',
        'surface.info.subtle': '#EBF3FE',
        'surface.info.translucent.default': '#3383EB66',
        'surface.info.translucent.strong': '#3383EB99',
        'surface.info.translucent.subtle': '#3383EB33',
        'surface.interactive': '#719CD3',
        'surface.inverse.default': '#1F2635',
        'surface.inverse.disabled': '#FDFDFC33',
        'surface.inverse.primary-neutral': '#9B988C',
        'surface.inverse.secondary-neutral': '#C6C3B9',
        'surface.inverse.selected': '#F2F7FC',
        'surface.inverse.selected-strong': '#FFFFFF',
        'surface.inverse.tertiary-neutral': '#EEECE7',
        'surface.overlay': '#28272566',
        'surface.primary': '#F5F6F8',
        'surface.primary-alt': '#F2F7FC',
        'surface.primary-neutral': '#F9F8F6',
        'surface.secondary': '#EDEEF2',
        'surface.secondary-alt': '#E2ECF7',
        'surface.secondary-neutral': '#F5F3F0',
        'surface.selected': '#F2F7FC',
        'surface.selected-strong': '#719CD3',
        'surface.strong-neutral': '#3E3B38',
        'surface.success.default': '#77C41E',
        'surface.success.low': '#B3EC6A',
        'surface.success.medium': '#457714',
        'surface.success.strong': '#182C07',
        'surface.success.subtle': '#E8FACD',
        'surface.success.translucent.default': '#77C41E66',
        'surface.success.translucent.strong': '#77C41E99',
        'surface.success.translucent.subtle': '#77C41E33',
        'surface.tertiary': '#DFE0E6',
        'surface.tertiary-alt': '#CCDEF1',
        'surface.tertiary-neutral': '#EEECE7',
        'surface.translucent.default': '#2827250A',
        'surface.translucent.disabled': '#2827251F',
        'surface.translucent.primary': '#7F7C9014',
        'surface.translucent.primary-alt': '#7F7C9014',
        'surface.translucent.primary-neutral': '#28272514',
        'surface.translucent.secondary': '#7F7C9029',
        'surface.translucent.secondary-alt': '#7F7C9029',
        'surface.translucent.secondary-neutral': '#28272529',
        'surface.translucent.selected': '#7F7C9029',
        'surface.translucent.strong-neutral': '#28272566',
        'surface.translucent.tertiary': '#7F7C9066',
        'surface.translucent.tertiary-alt': '#7F7C9033',
        'surface.translucent.tertiary-neutral': '#28272533',
        'surface.warning.default': '#D8AD1A',
        'surface.warning.low': '#EDD441',
        'surface.warning.medium': '#956213',
        'surface.warning.strong': '#3D220B',
        'surface.warning.subtle': '#F9F6C8',
        'surface.warning.translucent.default': '#D8AD1A66',
        'surface.warning.translucent.strong': '#D8AD1A99',
        'surface.warning.translucent.subtle': '#D8AD1A33',
        'text.brand': '#52525D',
        'text.brand-alt': '#DFE0E6',
        'text.disabled': '#28272566',
        'text.emphasized': '#4F7AC1',
        'text.error': '#BE171B',
        'text.info': '#2C6CBF',
        'text.interactive': '#4F7AC1',
        'text.inverse.disabled': '#FDFDFC66',
        'text.inverse.emphasized': '#E2ECF7',
        'text.inverse.interactive': '#CBCDD6',
        'text.inverse.primary': '#FFFFFF',
        'text.inverse.secondary': '#FDFDFCCC',
        'text.primary': '#1F2635',
        'text.secondary': '#6B6861',
        'text.secondary-1.default': '#77C41E',
        'text.secondary-1.low': '#B3EC6A',
        'text.secondary-1.medium': '#457714',
        'text.secondary-1.strong': '#325017',
        'text.secondary-1.subtle': '#F6FDE8',
        'text.secondary-2.default': '#EDD441',
        'text.secondary-2.low': '#F5EA93',
        'text.secondary-2.medium': '#D8AD1A',
        'text.secondary-2.strong': '#6A4019',
        'text.secondary-2.subtle': '#FCFBEA',
        'text.secondary-3.default': '#FFAD54',
        'text.secondary-3.low': '#FFDDA8',
        'text.secondary-3.medium': '#EF6707',
        'text.secondary-3.strong': '#7E3410',
        'text.secondary-3.subtle': '#FFF8ED',
        'text.secondary-4.default': '#FFA9AB',
        'text.secondary-4.low': '#FFCBCD',
        'text.secondary-4.medium': '#9F6B6E',
        'text.secondary-4.strong': '#3E2D30',
        'text.secondary-4.subtle': '#FFF7F7',
        'text.secondary-5.default': '#A0A7FF',
        'text.secondary-5.low': '#C6CAFF',
        'text.secondary-5.medium': '#666AA0',
        'text.secondary-5.strong': '#2B2C41',
        'text.secondary-5.subtle': '#F6F7FF',
        'text.selected': '#4F7AC1',
        'text.success': '#457714',
        'text.tertiary': '#C6C3B9',
        'text.warning': '#BB8713',
        white: '#FFFFFF',
        'white-label.footer.footer-bg': '#7F7C90',
        'white-label.header.bg': '#7F7C90',
        'white-label.header.on-header': '#FFFFFF',
        'white-label.headerSubtext': '#FFFFFF',
        'white-label.highlight': '#FFFFFF',
        'white-label.highlightText': '#FFFFFF',
        'white-label.notificationLogoBackground': '#FFFFFF',
        'white-label.publish-button.bg.header-bar': '#FFFFFF',
        'white-label.publish-button.bg.mobile-bottom-tab-bar': '#636271',
        'white-label.publish-button.icon.header-bar': '#1F2635',
        'white-label.publish-button.icon.mobile-bottom-tab-bar': '#FFFFFF',
        'white-label.publish-button.label.primary': '#1F2635',
        'white-label.splash': '#7F7C90',
        'white-label.theme.icon.on-brand-accent': '#1F2635',
        'white-label.theme.surface.accent': '#FFFFFF',
        'white-label.theme.surface.primary': '#7F7C90',
        'white-label.theme.text.on-brand-accent': '#1F2635',
      },
      responsive: {
        'border-width.bold': '4',
        'border-width.emphasized': '2',
        'border-width.standard': '1.5',
        'border-width.subtle': '1',
        'motion.distance.component-enter': '12',
        'motion.distance.feedback': '4',
        'motion.distance.overlay-enter': '24',
        'motion.distance.page-enter': '32',
        'motion.duration.component-transition': '[object Object]',
        'motion.duration.feedback': '[object Object]',
        'motion.duration.micro-transition': '[object Object]',
        'motion.duration.overlay-transition': '[object Object]',
        'motion.duration.page-transition': '[object Object]',
        'motion.duration.passive': '[object Object]',
        'motion.easing.continuous': '0,0,1,1',
        'motion.easing.emphasize': '0.05000000074505806,0.699999988079071,0.10000000149011612,1',
        'motion.easing.enter': '0,0,0,1',
        'motion.easing.exit': '0.4000000059604645,0,1,1',
        'motion.easing.move': '0.20000000298023224,0,0,1',
        'motion.scale.emphasize': '1.0199999809265137',
        'motion.scale.enter': '0.9599999785423279',
        'motion.scale.press': '0.9800000190734863',
        'motion.stagger.relaxed': '[object Object]',
        'motion.stagger.standard': '[object Object]',
        'motion.stagger.tight': '[object Object]',
        'radius.component.fields.input': '16',
        'radius.component.publish-button.button-radius': '8',
        'radius.full': '1000',
        'radius.lg': '16',
        'radius.md': '12',
        'radius.none': '0',
        'radius.sm': '8',
        'radius.xl': '24',
        'radius.xs': '4',
        'radius.xxl': '32',
        'radius.xxs': '2',
        'shadow.blur.lg': '32',
        'shadow.blur.md': '16',
        'shadow.blur.sm': '8',
        'shadow.blur.xl': '48',
        'shadow.blur.xs': '4',
        'shadow.offset-y.lg': '8',
        'shadow.offset-y.md': '4',
        'shadow.offset-y.sm': '2',
        'shadow.offset-y.xl': '16',
        'shadow.offset-y.xs': '1',
        'sizing.body.max-width': '1440',
        'sizing.body.min-width': '1280',
        'sizing.component.button.height.large': '56',
        'sizing.component.button.height.large-icn-button': '48',
        'sizing.component.button.height.medium': '40',
        'sizing.component.button.height.small': '32',
        'sizing.component.header.max-width': '1920',
        'sizing.component.header.min-width': '1280',
        'sizing.general.0': '0',
        'sizing.general.x0,25': '1',
        'sizing.general.x0,5': '2',
        'sizing.general.x1': '4',
        'sizing.general.x10': '40',
        'sizing.general.x100': '400',
        'sizing.general.x12': '48',
        'sizing.general.x120': '480',
        'sizing.general.x14': '56',
        'sizing.general.x140': '560',
        'sizing.general.x150': '600',
        'sizing.general.x16': '64',
        'sizing.general.x160': '640',
        'sizing.general.x18': '72',
        'sizing.general.x180': '720',
        'sizing.general.x2': '8',
        'sizing.general.x20': '80',
        'sizing.general.x200': '800',
        'sizing.general.x22': '88',
        'sizing.general.x24': '96',
        'sizing.general.x3': '12',
        'sizing.general.x30': '120',
        'sizing.general.x36': '144',
        'sizing.general.x4': '16',
        'sizing.general.x40': '160',
        'sizing.general.x5': '20',
        'sizing.general.x50': '200',
        'sizing.general.x6': '24',
        'sizing.general.x60': '240',
        'sizing.general.x7': '28',
        'sizing.general.x70': '280',
        'sizing.general.x8': '32',
        'sizing.general.x80': '320',
        'sizing.general.x90': '360',
        'sizing.icon.default': '24',
        'sizing.icon.lg': '32',
        'sizing.icon.s': '16',
        'sizing.icon.sm': '20',
        'sizing.icon.xl': '56',
        'sizing.icon.xs': '12',
        'spacing.general.0': '0',
        'spacing.general.x0,5': '2',
        'spacing.general.x1': '4',
        'spacing.general.x10': '40',
        'spacing.general.x12': '48',
        'spacing.general.x14': '56',
        'spacing.general.x16': '64',
        'spacing.general.x18': '72',
        'spacing.general.x2': '8',
        'spacing.general.x20': '80',
        'spacing.general.x22': '88',
        'spacing.general.x24': '96',
        'spacing.general.x3': '12',
        'spacing.general.x30': '120',
        'spacing.general.x36': '144',
        'spacing.general.x4': '16',
        'spacing.general.x5': '20',
        'spacing.general.x6': '24',
        'spacing.general.x7': '28',
        'spacing.general.x8': '32',
        'spacing.semantic.bottom-safe-zone': '36',
        'spacing.semantic.line-height-fix': '2',
        'spacing.semantic.page-margin': '48',
        'typography.font-size.body.base': '16',
        'typography.font-size.body.caption-base': '10',
        'typography.font-size.body.caption-large': '12',
        'typography.font-size.body.large': '18',
        'typography.font-size.body.small': '14',
        'typography.font-size.body.x-large': '20',
        'typography.font-size.body.x-small': '12',
        'typography.font-size.header.display-1': '56',
        'typography.font-size.header.display-2': '64',
        'typography.font-size.header.large': '48',
        'typography.font-size.header.medium': '40',
        'typography.font-size.header.small': '36',
        'typography.font-size.header.x-small': '32',
        'typography.font-size.link.link-base': '16',
        'typography.font-size.link.link-large': '20',
        'typography.font-size.link.link-small': '14',
        'typography.letter-spacing.body.base': '0',
        'typography.letter-spacing.body.caption': '0',
        'typography.letter-spacing.body.large': '0',
        'typography.letter-spacing.body.small': '0',
        'typography.letter-spacing.body.x-large': '0',
        'typography.letter-spacing.body.x-small': '0',
        'typography.letter-spacing.header.display-1': '0',
        'typography.letter-spacing.header.display-2': '0',
        'typography.letter-spacing.header.large': '0',
        'typography.letter-spacing.header.medium': '0',
        'typography.letter-spacing.header.small': '0',
        'typography.letter-spacing.header.x-small': '0',
      },
      styles: {
        header: {
          'display-2': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '64',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'display-1': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '56',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '48',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '48', letterSpacing: '0', lineHeight: 'normal' },
          },
          medium: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '40',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'medium-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '40', letterSpacing: '0', lineHeight: 'normal' },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '36',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '36', letterSpacing: '0', lineHeight: 'normal' },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '32',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '32', letterSpacing: '0', lineHeight: 'normal' },
          },
        },
        body: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontWeight: '700', fontSize: '18', letterSpacing: '0', lineHeight: '120%' },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontWeight: '400', fontSize: '14', letterSpacing: '0', lineHeight: '120%' },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        caption: {
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        paragraph: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        link: {
          'link-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
        },
      },
    },
  },
  dark: {
    small: {
      brand: 'refrain',
      mode: 'dark',
      breakpoint: 'small',
      colors: {
        black: '#1F2635',
        'border.brand': '#DFE0E6',
        'border.brand-alt': '#354973',
        'border.disabled': '#28272529',
        'border.divider': '#FDFDFC33',
        'border.error': '#FD6C6F',
        'border.focused': '#81ADD9',
        'border.info': '#5C9CEF',
        'border.interactive': '#81ADD9',
        'border.inverse.disabled': '#28272566',
        'border.inverse.divider': '#2827251F',
        'border.inverse.interactive': '#A0A0B4',
        'border.inverse.primary': '#28272566',
        'border.inverse.secondary': '#28272529',
        'border.inverse.selected': '#7F7C90',
        'border.inverse.strong': '#1F2635',
        'border.primary': '#FDFDFC66',
        'border.secondary': '#FDFDFC29',
        'border.secondary-1.default': '#96DF3C',
        'border.secondary-1.strong': '#F6FDE8',
        'border.secondary-1.subtle': '#457714',
        'border.secondary-2.default': '#E8C427',
        'border.secondary-2.strong': '#FCFBEA',
        'border.secondary-2.subtle': '#956213',
        'border.secondary-3.default': '#FFAD54',
        'border.secondary-3.strong': '#FFF8ED',
        'border.secondary-3.subtle': '#C64C08',
        'border.secondary-4.default': '#FFBABC',
        'border.secondary-4.strong': '#FFF7F7',
        'border.secondary-4.subtle': '#9F6B6E',
        'border.secondary-5.default': '#B3B8FF',
        'border.secondary-5.low': '#666AA0',
        'border.secondary-5.medium': '#D9DCFF',
        'border.secondary-5.strong': '#F6F7FF',
        'border.secondary-5.subtle': '#2B2C41',
        'border.selected': '#4467B1',
        'border.strong': '#FFFFFF',
        'border.success': '#96DF3C',
        'border.warning': '#E8C427',
        'component.button.bg.hover': '#FDFDFC33',
        'component.button.bg.inverted': '#1F2635',
        'component.button.bg.pressed': '#28272566',
        'component.button.bg.primary': '#FFFFFF',
        'component.button.bg.secondary': '#DFE0E6',
        'component.button.bg.tertiary': '#3E3B38',
        'component.button.bg.transparent': '#FDFDFC66',
        'component.button.border.tertiary': '#FFFFFF',
        'component.button.icon.tertiary': '#DFE0E6',
        'component.button.label.tertiary': '#DFE0E6',
        'concept.ambassador.border': '#7C4D17',
        'concept.ambassador.icon': '#E8C427',
        'concept.ambassador.surface.default': '#E8C427',
        'concept.ambassador.surface.strong': '#F9F6C8',
        'concept.ambassador.surface.subtle': '#3D220B',
        'concept.ambassador.text': '#EDD441',
        'concept.exoneration.border': '#9D3D0F',
        'concept.exoneration.icon': '#FFAD54',
        'concept.exoneration.surface.default': '#B4B5C5',
        'concept.exoneration.surface.low': '#EDEEF2',
        'concept.exoneration.surface.medium': '#DFE0E6',
        'concept.exoneration.surface.strong': '#EDEEF2',
        'concept.exoneration.surface.subtle': '#303036',
        'concept.exoneration.text': '#FFC471',
        'concept.pension.border': '#3A5F15',
        'concept.pension.icon': '#96DF3C',
        'concept.pension.surface.default': '#5C9CEF',
        'concept.pension.surface.strong': '#D6E6FB',
        'concept.pension.surface.subtle': '#121A27',
        'concept.pension.text-on-dark': '#B3EC6A',
        'concept.pension.text-on-light': '#B3EC6A',
        'concept.plan.free.icon-on-surface': '#FFFFFF',
        'concept.plan.free.surface.default': '#5C9CEF',
        'concept.plan.free.surface.low': '#1C3C68',
        'concept.plan.free.surface.medium': '#ADCDF7',
        'concept.plan.free.surface.strong': '#D6E6FB',
        'concept.plan.free.surface.subtle': '#121A27',
        'concept.plan.free.text-on-surface': '#FFFFFF',
        'concept.plan.premium.accent': '#F5EA93',
        'concept.plan.premium.border': '#484B70',
        'concept.plan.premium.icon-on-surface': '#B3B8FF',
        'concept.plan.premium.surface.default': '#B3B8FF',
        'concept.plan.premium.surface.low': '#484B70',
        'concept.plan.premium.surface.medium': '#D9DCFF',
        'concept.plan.premium.surface.strong': '#ECEDFF',
        'concept.plan.premium.surface.subtle': '#1D1E28',
        'concept.plan.premium.text-on-surface': '#C6CAFF',
        'concept.trust-club.border': '#6E4C4E',
        'concept.trust-club.icon': '#FFBABC',
        'concept.trust-club.surface.default': '#FFBABC',
        'concept.trust-club.surface.strong': '#FFEEEE',
        'concept.trust-club.surface.subtle': '#261E20',
        'concept.trust-club.text-on-dark': '#FFCBCD',
        'concept.trust-club.text-on-light': '#FFCBCD',
        'gradient.bottom-tab-bar-end': '#161616E5',
        'gradient.bottom-tab-bar-start': '#16161600',
        'gradient.primary': '#16161600',
        'icon.brand': '#DFE0E6',
        'icon.brand-alt': '#52525D',
        'icon.disabled': '#FDFDFC66',
        'icon.emphasized': '#B4B5C5',
        'icon.error': '#FD6C6F',
        'icon.info': '#85B5F3',
        'icon.interactive': '#81ADD9',
        'icon.inverse.disabled': '#28272566',
        'icon.inverse.interactive': '#A0A0B4',
        'icon.inverse.on-selected': '#B4B5C5',
        'icon.inverse.primary': '#1F2635',
        'icon.inverse.secondary': '#6B6861',
        'icon.primary': '#FFFFFF',
        'icon.secondary': '#C6C3B9',
        'icon.secondary-1.default': '#96DF3C',
        'icon.secondary-1.low': '#457714',
        'icon.secondary-1.medium': '#CDF496',
        'icon.secondary-1.strong': '#F6FDE8',
        'icon.secondary-1.subtle': '#325017',
        'icon.secondary-2.default': '#E8C427',
        'icon.secondary-2.low': '#956213',
        'icon.secondary-2.medium': '#F5EA93',
        'icon.secondary-2.strong': '#FCFBEA',
        'icon.secondary-2.subtle': '#6A4019',
        'icon.secondary-3.default': '#FFAD54',
        'icon.secondary-3.low': '#C64C08',
        'icon.secondary-3.medium': '#FFDDA8',
        'icon.secondary-3.strong': '#FFF8ED',
        'icon.secondary-3.subtle': '#7E3410',
        'icon.secondary-4.default': '#FFBABC',
        'icon.secondary-4.low': '#9F6B6E',
        'icon.secondary-4.medium': '#FFDDDD',
        'icon.secondary-4.strong': '#FFF7F7',
        'icon.secondary-4.subtle': '#3E2D30',
        'icon.secondary-5.default': '#B3B8FF',
        'icon.secondary-5.low': '#666AA0',
        'icon.secondary-5.medium': '#D9DCFF',
        'icon.secondary-5.strong': '#F6F7FF',
        'icon.secondary-5.subtle': '#2B2C41',
        'icon.selected': '#81ADD9',
        'icon.success': '#96DF3C',
        'icon.tertiary': '#6B6861',
        'icon.warning': '#EDD441',
        page: '#161616',
        'shadow.inner': '#FDFDFC33',
        'shadow.lg': '#28272599',
        'shadow.md': '#28272566',
        'shadow.sm': '#28272533',
        'shadow.xl': '#282725CC',
        'shadow.xs': '#2827251F',
        'state-layer.hover': '#FDFDFC14',
        'state-layer.hover-alt': '#28272529',
        'state-layer.hover-brand': '#7F7C9029',
        'state-layer.hover-on-color': '#FDFDFC33',
        'state-layer.inverse.hover': '#28272514',
        'state-layer.inverse.hover-brand': '#7F7C9033',
        'state-layer.inverse.hover-on-color': '#FDFDFC33',
        'state-layer.inverse.press': '#28272529',
        'state-layer.inverse.press-brand': '#7F7C9066',
        'state-layer.inverse.press-on-color': '#28272566',
        'state-layer.press': '#FDFDFC29',
        'state-layer.press-alt': '#28272566',
        'state-layer.press-brand': '#7F7C9066',
        'state-layer.press-on-color': '#FDFDFC66',
        'surface.brand.bold': '#F5F6F8',
        'surface.brand.bold-alt': '#E2ECF7',
        'surface.brand.default': '#B4B5C5',
        'surface.brand.default-alt': '#81ADD9',
        'surface.brand.secondary-1.default': '#96DF3C',
        'surface.brand.secondary-1.low': '#457714',
        'surface.brand.secondary-1.medium': '#CDF496',
        'surface.brand.secondary-1.strong': '#F6FDE8',
        'surface.brand.secondary-1.subtle': '#325017',
        'surface.brand.secondary-1.translucent.default': '#CDF49633',
        'surface.brand.secondary-1.translucent.low': '#CDF49614',
        'surface.brand.secondary-1.translucent.medium': '#CDF49666',
        'surface.brand.secondary-1.translucent.strong': '#CDF49699',
        'surface.brand.secondary-1.translucent.subtle': '#CDF4960A',
        'surface.brand.secondary-2.default': '#F5EA93',
        'surface.brand.secondary-2.low': '#956213',
        'surface.brand.secondary-2.medium': '#E8C427',
        'surface.brand.secondary-2.strong': '#FCFBEA',
        'surface.brand.secondary-2.subtle': '#6A4019',
        'surface.brand.secondary-2.translucent.default': '#EDD44133',
        'surface.brand.secondary-2.translucent.low': '#EDD44114',
        'surface.brand.secondary-2.translucent.medium': '#EDD44166',
        'surface.brand.secondary-2.translucent.strong': '#EDD44199',
        'surface.brand.secondary-2.translucent.subtle': '#EDD4410A',
        'surface.brand.secondary-3.default': '#FFC471',
        'surface.brand.secondary-3.low': '#C64C08',
        'surface.brand.secondary-3.medium': '#FFDDA8',
        'surface.brand.secondary-3.strong': '#FFF8ED',
        'surface.brand.secondary-3.subtle': '#7E3410',
        'surface.brand.secondary-3.translucent.default': '#FFAD5433',
        'surface.brand.secondary-3.translucent.low': '#FFAD5414',
        'surface.brand.secondary-3.translucent.medium': '#FFAD5466',
        'surface.brand.secondary-3.translucent.strong': '#FFAD5499',
        'surface.brand.secondary-3.translucent.subtle': '#FFAD540A',
        'surface.brand.secondary-4.default': '#FFBABC',
        'surface.brand.secondary-4.low': '#9F6B6E',
        'surface.brand.secondary-4.medium': '#FFDDDD',
        'surface.brand.secondary-4.strong': '#FFF7F7',
        'surface.brand.secondary-4.subtle': '#3E2D30',
        'surface.brand.secondary-4.translucent.default': '#FFA9AB33',
        'surface.brand.secondary-4.translucent.low': '#FFA9AB14',
        'surface.brand.secondary-4.translucent.medium': '#FFA9AB66',
        'surface.brand.secondary-4.translucent.strong': '#FFA9AB99',
        'surface.brand.secondary-4.translucent.subtle': '#FFA9AB0A',
        'surface.brand.secondary-5.default': '#B3B8FF',
        'surface.brand.secondary-5.low': '#666AA0',
        'surface.brand.secondary-5.medium': '#D9DCFF',
        'surface.brand.secondary-5.strong': '#F6F7FF',
        'surface.brand.secondary-5.subtle': '#2B2C41',
        'surface.brand.secondary-5.translucent.default': '#A0A7FF33',
        'surface.brand.secondary-5.translucent.low': '#A0A7FF14',
        'surface.brand.secondary-5.translucent.medium': '#A0A7FF66',
        'surface.brand.secondary-5.translucent.strong': '#A0A7FF99',
        'surface.brand.secondary-5.translucent.subtle': '#A0A7FF0A',
        'surface.brand.strong': '#F5F6F8',
        'surface.brand.strong-alt': '#F2F7FC',
        'surface.brand.subtle': '#7F7C90',
        'surface.brand.subtle-alt': '#4467B1',
        'surface.brand.translucent.bold': '#7F7C9066',
        'surface.brand.translucent.bold-alt': '#7F7C9066',
        'surface.brand.translucent.default': '#7F7C9033',
        'surface.brand.translucent.strong': '#7F7C9066',
        'surface.brand.translucent.strong-alt': '#7F7C9066',
        'surface.brand.translucent.subtle': '#7F7C9014',
        'surface.default': '#282725',
        'surface.disabled': '#FDFDFC33',
        'surface.error.default': '#FD6C6F',
        'surface.error.low': '#BE171B',
        'surface.error.medium': '#FFC8C9',
        'surface.error.strong': '#FEF2F2',
        'surface.error.subtle': '#470809',
        'surface.error.translucent.default': '#F53E4266',
        'surface.error.translucent.strong': '#F53E4299',
        'surface.error.translucent.subtle': '#F53E4229',
        'surface.info.default': '#5C9CEF',
        'surface.info.low': '#255594',
        'surface.info.medium': '#ADCDF7',
        'surface.info.strong': '#EBF3FE',
        'surface.info.subtle': '#121A27',
        'surface.info.translucent.default': '#3383EB66',
        'surface.info.translucent.strong': '#3383EB99',
        'surface.info.translucent.subtle': '#3383EB29',
        'surface.interactive': '#81ADD9',
        'surface.inverse.default': '#FFFFFF',
        'surface.inverse.disabled': '#28272533',
        'surface.inverse.primary-neutral': '#9B988C',
        'surface.inverse.secondary-neutral': '#6B6861',
        'surface.inverse.selected': '#4467B1',
        'surface.inverse.selected-strong': '#FFFFFF',
        'surface.inverse.tertiary-neutral': '#3E3B38',
        'surface.overlay': '#28272566',
        'surface.primary': '#7F7C9014',
        'surface.primary-alt': '#242E47',
        'surface.primary-neutral': '#28272599',
        'surface.secondary': '#7F7C901F',
        'surface.secondary-alt': '#354973',
        'surface.secondary-neutral': '#FDFDFC14',
        'surface.selected': '#4467B1',
        'surface.selected-strong': '#81ADD9',
        'surface.strong-neutral': '#282725CC',
        'surface.success.default': '#96DF3C',
        'surface.success.low': '#457714',
        'surface.success.medium': '#CDF496',
        'surface.success.strong': '#F6FDE8',
        'surface.success.subtle': '#182C07',
        'surface.success.translucent.default': '#77C41E66',
        'surface.success.translucent.strong': '#77C41E99',
        'surface.success.translucent.subtle': '#77C41E29',
        'surface.tertiary': '#7F7C9029',
        'surface.tertiary-alt': '#3D5590',
        'surface.tertiary-neutral': '#FDFDFC29',
        'surface.translucent.default': '#2827250A',
        'surface.translucent.disabled': '#FDFDFC1F',
        'surface.translucent.primary': '#7F7C9014',
        'surface.translucent.primary-alt': '#7F7C9014',
        'surface.translucent.primary-neutral': '#FDFDFC14',
        'surface.translucent.secondary': '#7F7C9029',
        'surface.translucent.secondary-alt': '#7F7C9029',
        'surface.translucent.secondary-neutral': '#FDFDFC29',
        'surface.translucent.selected': '#7F7C9029',
        'surface.translucent.strong-neutral': '#FDFDFC66',
        'surface.translucent.tertiary': '#7F7C9066',
        'surface.translucent.tertiary-alt': '#7F7C9033',
        'surface.translucent.tertiary-neutral': '#FDFDFC33',
        'surface.warning.default': '#E8C427',
        'surface.warning.low': '#956213',
        'surface.warning.medium': '#F5EA93',
        'surface.warning.strong': '#FCFBEA',
        'surface.warning.subtle': '#3D220B',
        'surface.warning.translucent.default': '#D8AD1A66',
        'surface.warning.translucent.strong': '#D8AD1A99',
        'surface.warning.translucent.subtle': '#D8AD1A29',
        'text.brand': '#DFE0E6',
        'text.brand-alt': '#52525D',
        'text.disabled': '#FDFDFC66',
        'text.emphasized': '#81ADD9',
        'text.error': '#FD6C6F',
        'text.info': '#85B5F3',
        'text.interactive': '#81ADD9',
        'text.inverse.disabled': '#28272566',
        'text.inverse.emphasized': '#4467B1',
        'text.inverse.interactive': '#A0A0B4',
        'text.inverse.primary': '#282725',
        'text.inverse.secondary': '#6B6861',
        'text.primary': '#FFFFFF',
        'text.secondary': '#C6C3B9',
        'text.secondary-1.default': '#96DF3C',
        'text.secondary-1.low': '#457714',
        'text.secondary-1.medium': '#CDF496',
        'text.secondary-1.strong': '#F6FDE8',
        'text.secondary-1.subtle': '#325017',
        'text.secondary-2.default': '#F5EA93',
        'text.secondary-2.low': '#956213',
        'text.secondary-2.medium': '#E8C427',
        'text.secondary-2.strong': '#FCFBEA',
        'text.secondary-2.subtle': '#6A4019',
        'text.secondary-3.default': '#FFC471',
        'text.secondary-3.low': '#C64C08',
        'text.secondary-3.medium': '#FFDDA8',
        'text.secondary-3.strong': '#FFF8ED',
        'text.secondary-3.subtle': '#7E3410',
        'text.secondary-4.default': '#FFBABC',
        'text.secondary-4.low': '#9F6B6E',
        'text.secondary-4.medium': '#FFDDDD',
        'text.secondary-4.strong': '#FFF7F7',
        'text.secondary-4.subtle': '#3E2D30',
        'text.secondary-5.default': '#B3B8FF',
        'text.secondary-5.low': '#666AA0',
        'text.secondary-5.medium': '#D9DCFF',
        'text.secondary-5.strong': '#F6F7FF',
        'text.secondary-5.subtle': '#2B2C41',
        'text.selected': '#81ADD9',
        'text.success': '#96DF3C',
        'text.tertiary': '#6B6861',
        'text.warning': '#EDD441',
        white: '#FFFFFF',
        'white-label.footer.footer-bg': '#1F2635',
        'white-label.header.bg': '#161616',
        'white-label.header.on-header': '#FFFFFF',
        'white-label.headerSubtext': '#FFFFFF',
        'white-label.highlight': '#FFFFFF',
        'white-label.highlightText': '#FFFFFF',
        'white-label.notificationLogoBackground': '#FFFFFF',
        'white-label.publish-button.bg.header-bar': '#636271',
        'white-label.publish-button.bg.mobile-bottom-tab-bar': '#636271',
        'white-label.publish-button.icon.header-bar': '#FFFFFF',
        'white-label.publish-button.icon.mobile-bottom-tab-bar': '#FFFFFF',
        'white-label.publish-button.label.primary': '#FFFFFF',
        'white-label.splash': '#7F7C90',
        'white-label.theme.icon.on-brand-accent': '#FFFFFF',
        'white-label.theme.surface.accent': '#7F7C90',
        'white-label.theme.surface.primary': '#1F2635',
        'white-label.theme.text.on-brand-accent': '#FFFFFF',
      },
      responsive: {
        'border-width.bold': '4',
        'border-width.emphasized': '2',
        'border-width.standard': '1.5',
        'border-width.subtle': '1',
        'motion.distance.component-enter': '8',
        'motion.distance.feedback': '2',
        'motion.distance.overlay-enter': '12',
        'motion.distance.page-enter': '16',
        'motion.duration.component-transition': '[object Object]',
        'motion.duration.feedback': '[object Object]',
        'motion.duration.micro-transition': '[object Object]',
        'motion.duration.overlay-transition': '[object Object]',
        'motion.duration.page-transition': '[object Object]',
        'motion.duration.passive': '[object Object]',
        'motion.easing.continuous': '0,0,1,1',
        'motion.easing.emphasize': '0.05000000074505806,0.699999988079071,0.10000000149011612,1',
        'motion.easing.enter': '0,0,0,1',
        'motion.easing.exit': '0.4000000059604645,0,1,1',
        'motion.easing.move': '0.20000000298023224,0,0,1',
        'motion.scale.emphasize': '1.0199999809265137',
        'motion.scale.enter': '0.9599999785423279',
        'motion.scale.press': '0.9800000190734863',
        'motion.stagger.relaxed': '[object Object]',
        'motion.stagger.standard': '[object Object]',
        'motion.stagger.tight': '[object Object]',
        'radius.component.fields.input': '16',
        'radius.component.publish-button.button-radius': '8',
        'radius.full': '1000',
        'radius.lg': '16',
        'radius.md': '12',
        'radius.none': '0',
        'radius.sm': '8',
        'radius.xl': '24',
        'radius.xs': '4',
        'radius.xxl': '32',
        'radius.xxs': '2',
        'shadow.blur.lg': '16',
        'shadow.blur.md': '8',
        'shadow.blur.sm': '4',
        'shadow.blur.xl': '24',
        'shadow.blur.xs': '2',
        'shadow.offset-y.lg': '4',
        'shadow.offset-y.md': '2',
        'shadow.offset-y.sm': '1',
        'shadow.offset-y.xl': '8',
        'shadow.offset-y.xs': '1',
        'sizing.body.max-width': '767',
        'sizing.body.min-width': '320',
        'sizing.component.button.height.large': '56',
        'sizing.component.button.height.large-icn-button': '48',
        'sizing.component.button.height.medium': '40',
        'sizing.component.button.height.small': '32',
        'sizing.component.header.max-width': '767',
        'sizing.component.header.min-width': '320',
        'sizing.general.0': '0',
        'sizing.general.x0,25': '1',
        'sizing.general.x0,5': '2',
        'sizing.general.x1': '4',
        'sizing.general.x10': '40',
        'sizing.general.x100': '400',
        'sizing.general.x12': '48',
        'sizing.general.x120': '480',
        'sizing.general.x14': '56',
        'sizing.general.x140': '560',
        'sizing.general.x150': '600',
        'sizing.general.x16': '64',
        'sizing.general.x160': '640',
        'sizing.general.x18': '72',
        'sizing.general.x180': '720',
        'sizing.general.x2': '8',
        'sizing.general.x20': '80',
        'sizing.general.x200': '800',
        'sizing.general.x22': '88',
        'sizing.general.x24': '96',
        'sizing.general.x3': '12',
        'sizing.general.x30': '120',
        'sizing.general.x36': '144',
        'sizing.general.x4': '16',
        'sizing.general.x40': '160',
        'sizing.general.x5': '20',
        'sizing.general.x50': '200',
        'sizing.general.x6': '24',
        'sizing.general.x60': '240',
        'sizing.general.x7': '28',
        'sizing.general.x70': '280',
        'sizing.general.x8': '32',
        'sizing.general.x80': '320',
        'sizing.general.x90': '360',
        'sizing.icon.default': '24',
        'sizing.icon.lg': '32',
        'sizing.icon.s': '16',
        'sizing.icon.sm': '20',
        'sizing.icon.xl': '56',
        'sizing.icon.xs': '12',
        'spacing.general.0': '0',
        'spacing.general.x0,5': '2',
        'spacing.general.x1': '4',
        'spacing.general.x10': '40',
        'spacing.general.x12': '48',
        'spacing.general.x14': '56',
        'spacing.general.x16': '64',
        'spacing.general.x18': '72',
        'spacing.general.x2': '8',
        'spacing.general.x20': '80',
        'spacing.general.x22': '88',
        'spacing.general.x24': '96',
        'spacing.general.x3': '12',
        'spacing.general.x30': '120',
        'spacing.general.x36': '144',
        'spacing.general.x4': '16',
        'spacing.general.x5': '20',
        'spacing.general.x6': '24',
        'spacing.general.x7': '28',
        'spacing.general.x8': '32',
        'spacing.semantic.bottom-safe-zone': '36',
        'spacing.semantic.line-height-fix': '2',
        'spacing.semantic.page-margin': '16',
        'typography.font-size.body.base': '16',
        'typography.font-size.body.caption-base': '10',
        'typography.font-size.body.caption-large': '12',
        'typography.font-size.body.large': '18',
        'typography.font-size.body.small': '14',
        'typography.font-size.body.x-large': '20',
        'typography.font-size.body.x-small': '12',
        'typography.font-size.header.display-1': '48',
        'typography.font-size.header.display-2': '56',
        'typography.font-size.header.large': '40',
        'typography.font-size.header.medium': '28',
        'typography.font-size.header.small': '24',
        'typography.font-size.header.x-small': '20',
        'typography.font-size.link.link-base': '16',
        'typography.font-size.link.link-large': '20',
        'typography.font-size.link.link-small': '14',
        'typography.letter-spacing.body.base': '0',
        'typography.letter-spacing.body.caption': '0',
        'typography.letter-spacing.body.large': '0',
        'typography.letter-spacing.body.small': '0',
        'typography.letter-spacing.body.x-large': '0',
        'typography.letter-spacing.body.x-small': '0',
        'typography.letter-spacing.header.display-1': '0',
        'typography.letter-spacing.header.display-2': '0',
        'typography.letter-spacing.header.large': '0',
        'typography.letter-spacing.header.medium': '0',
        'typography.letter-spacing.header.small': '0',
        'typography.letter-spacing.header.x-small': '0',
      },
      styles: {
        header: {
          'display-2': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '56',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'display-1': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '48',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '40',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '40', letterSpacing: '0', lineHeight: 'normal' },
          },
          medium: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '28',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'medium-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '28', letterSpacing: '0', lineHeight: 'normal' },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '24',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '24', letterSpacing: '0', lineHeight: 'normal' },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '20', letterSpacing: '0', lineHeight: 'normal' },
          },
        },
        body: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontWeight: '700', fontSize: '18', letterSpacing: '0', lineHeight: '120%' },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontWeight: '400', fontSize: '14', letterSpacing: '0', lineHeight: '120%' },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        caption: {
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        paragraph: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        link: {
          'link-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
        },
      },
    },
    medium: {
      brand: 'refrain',
      mode: 'dark',
      breakpoint: 'medium',
      colors: {
        black: '#1F2635',
        'border.brand': '#DFE0E6',
        'border.brand-alt': '#354973',
        'border.disabled': '#28272529',
        'border.divider': '#FDFDFC33',
        'border.error': '#FD6C6F',
        'border.focused': '#81ADD9',
        'border.info': '#5C9CEF',
        'border.interactive': '#81ADD9',
        'border.inverse.disabled': '#28272566',
        'border.inverse.divider': '#2827251F',
        'border.inverse.interactive': '#A0A0B4',
        'border.inverse.primary': '#28272566',
        'border.inverse.secondary': '#28272529',
        'border.inverse.selected': '#7F7C90',
        'border.inverse.strong': '#1F2635',
        'border.primary': '#FDFDFC66',
        'border.secondary': '#FDFDFC29',
        'border.secondary-1.default': '#96DF3C',
        'border.secondary-1.strong': '#F6FDE8',
        'border.secondary-1.subtle': '#457714',
        'border.secondary-2.default': '#E8C427',
        'border.secondary-2.strong': '#FCFBEA',
        'border.secondary-2.subtle': '#956213',
        'border.secondary-3.default': '#FFAD54',
        'border.secondary-3.strong': '#FFF8ED',
        'border.secondary-3.subtle': '#C64C08',
        'border.secondary-4.default': '#FFBABC',
        'border.secondary-4.strong': '#FFF7F7',
        'border.secondary-4.subtle': '#9F6B6E',
        'border.secondary-5.default': '#B3B8FF',
        'border.secondary-5.low': '#666AA0',
        'border.secondary-5.medium': '#D9DCFF',
        'border.secondary-5.strong': '#F6F7FF',
        'border.secondary-5.subtle': '#2B2C41',
        'border.selected': '#4467B1',
        'border.strong': '#FFFFFF',
        'border.success': '#96DF3C',
        'border.warning': '#E8C427',
        'component.button.bg.hover': '#FDFDFC33',
        'component.button.bg.inverted': '#1F2635',
        'component.button.bg.pressed': '#28272566',
        'component.button.bg.primary': '#FFFFFF',
        'component.button.bg.secondary': '#DFE0E6',
        'component.button.bg.tertiary': '#3E3B38',
        'component.button.bg.transparent': '#FDFDFC66',
        'component.button.border.tertiary': '#FFFFFF',
        'component.button.icon.tertiary': '#DFE0E6',
        'component.button.label.tertiary': '#DFE0E6',
        'concept.ambassador.border': '#7C4D17',
        'concept.ambassador.icon': '#E8C427',
        'concept.ambassador.surface.default': '#E8C427',
        'concept.ambassador.surface.strong': '#F9F6C8',
        'concept.ambassador.surface.subtle': '#3D220B',
        'concept.ambassador.text': '#EDD441',
        'concept.exoneration.border': '#9D3D0F',
        'concept.exoneration.icon': '#FFAD54',
        'concept.exoneration.surface.default': '#B4B5C5',
        'concept.exoneration.surface.low': '#EDEEF2',
        'concept.exoneration.surface.medium': '#DFE0E6',
        'concept.exoneration.surface.strong': '#EDEEF2',
        'concept.exoneration.surface.subtle': '#303036',
        'concept.exoneration.text': '#FFC471',
        'concept.pension.border': '#3A5F15',
        'concept.pension.icon': '#96DF3C',
        'concept.pension.surface.default': '#5C9CEF',
        'concept.pension.surface.strong': '#D6E6FB',
        'concept.pension.surface.subtle': '#121A27',
        'concept.pension.text-on-dark': '#B3EC6A',
        'concept.pension.text-on-light': '#B3EC6A',
        'concept.plan.free.icon-on-surface': '#FFFFFF',
        'concept.plan.free.surface.default': '#5C9CEF',
        'concept.plan.free.surface.low': '#1C3C68',
        'concept.plan.free.surface.medium': '#ADCDF7',
        'concept.plan.free.surface.strong': '#D6E6FB',
        'concept.plan.free.surface.subtle': '#121A27',
        'concept.plan.free.text-on-surface': '#FFFFFF',
        'concept.plan.premium.accent': '#F5EA93',
        'concept.plan.premium.border': '#484B70',
        'concept.plan.premium.icon-on-surface': '#B3B8FF',
        'concept.plan.premium.surface.default': '#B3B8FF',
        'concept.plan.premium.surface.low': '#484B70',
        'concept.plan.premium.surface.medium': '#D9DCFF',
        'concept.plan.premium.surface.strong': '#ECEDFF',
        'concept.plan.premium.surface.subtle': '#1D1E28',
        'concept.plan.premium.text-on-surface': '#C6CAFF',
        'concept.trust-club.border': '#6E4C4E',
        'concept.trust-club.icon': '#FFBABC',
        'concept.trust-club.surface.default': '#FFBABC',
        'concept.trust-club.surface.strong': '#FFEEEE',
        'concept.trust-club.surface.subtle': '#261E20',
        'concept.trust-club.text-on-dark': '#FFCBCD',
        'concept.trust-club.text-on-light': '#FFCBCD',
        'gradient.bottom-tab-bar-end': '#161616E5',
        'gradient.bottom-tab-bar-start': '#16161600',
        'gradient.primary': '#16161600',
        'icon.brand': '#DFE0E6',
        'icon.brand-alt': '#52525D',
        'icon.disabled': '#FDFDFC66',
        'icon.emphasized': '#B4B5C5',
        'icon.error': '#FD6C6F',
        'icon.info': '#85B5F3',
        'icon.interactive': '#81ADD9',
        'icon.inverse.disabled': '#28272566',
        'icon.inverse.interactive': '#A0A0B4',
        'icon.inverse.on-selected': '#B4B5C5',
        'icon.inverse.primary': '#1F2635',
        'icon.inverse.secondary': '#6B6861',
        'icon.primary': '#FFFFFF',
        'icon.secondary': '#C6C3B9',
        'icon.secondary-1.default': '#96DF3C',
        'icon.secondary-1.low': '#457714',
        'icon.secondary-1.medium': '#CDF496',
        'icon.secondary-1.strong': '#F6FDE8',
        'icon.secondary-1.subtle': '#325017',
        'icon.secondary-2.default': '#E8C427',
        'icon.secondary-2.low': '#956213',
        'icon.secondary-2.medium': '#F5EA93',
        'icon.secondary-2.strong': '#FCFBEA',
        'icon.secondary-2.subtle': '#6A4019',
        'icon.secondary-3.default': '#FFAD54',
        'icon.secondary-3.low': '#C64C08',
        'icon.secondary-3.medium': '#FFDDA8',
        'icon.secondary-3.strong': '#FFF8ED',
        'icon.secondary-3.subtle': '#7E3410',
        'icon.secondary-4.default': '#FFBABC',
        'icon.secondary-4.low': '#9F6B6E',
        'icon.secondary-4.medium': '#FFDDDD',
        'icon.secondary-4.strong': '#FFF7F7',
        'icon.secondary-4.subtle': '#3E2D30',
        'icon.secondary-5.default': '#B3B8FF',
        'icon.secondary-5.low': '#666AA0',
        'icon.secondary-5.medium': '#D9DCFF',
        'icon.secondary-5.strong': '#F6F7FF',
        'icon.secondary-5.subtle': '#2B2C41',
        'icon.selected': '#81ADD9',
        'icon.success': '#96DF3C',
        'icon.tertiary': '#6B6861',
        'icon.warning': '#EDD441',
        page: '#161616',
        'shadow.inner': '#FDFDFC33',
        'shadow.lg': '#28272599',
        'shadow.md': '#28272566',
        'shadow.sm': '#28272533',
        'shadow.xl': '#282725CC',
        'shadow.xs': '#2827251F',
        'state-layer.hover': '#FDFDFC14',
        'state-layer.hover-alt': '#28272529',
        'state-layer.hover-brand': '#7F7C9029',
        'state-layer.hover-on-color': '#FDFDFC33',
        'state-layer.inverse.hover': '#28272514',
        'state-layer.inverse.hover-brand': '#7F7C9033',
        'state-layer.inverse.hover-on-color': '#FDFDFC33',
        'state-layer.inverse.press': '#28272529',
        'state-layer.inverse.press-brand': '#7F7C9066',
        'state-layer.inverse.press-on-color': '#28272566',
        'state-layer.press': '#FDFDFC29',
        'state-layer.press-alt': '#28272566',
        'state-layer.press-brand': '#7F7C9066',
        'state-layer.press-on-color': '#FDFDFC66',
        'surface.brand.bold': '#F5F6F8',
        'surface.brand.bold-alt': '#E2ECF7',
        'surface.brand.default': '#B4B5C5',
        'surface.brand.default-alt': '#81ADD9',
        'surface.brand.secondary-1.default': '#96DF3C',
        'surface.brand.secondary-1.low': '#457714',
        'surface.brand.secondary-1.medium': '#CDF496',
        'surface.brand.secondary-1.strong': '#F6FDE8',
        'surface.brand.secondary-1.subtle': '#325017',
        'surface.brand.secondary-1.translucent.default': '#CDF49633',
        'surface.brand.secondary-1.translucent.low': '#CDF49614',
        'surface.brand.secondary-1.translucent.medium': '#CDF49666',
        'surface.brand.secondary-1.translucent.strong': '#CDF49699',
        'surface.brand.secondary-1.translucent.subtle': '#CDF4960A',
        'surface.brand.secondary-2.default': '#F5EA93',
        'surface.brand.secondary-2.low': '#956213',
        'surface.brand.secondary-2.medium': '#E8C427',
        'surface.brand.secondary-2.strong': '#FCFBEA',
        'surface.brand.secondary-2.subtle': '#6A4019',
        'surface.brand.secondary-2.translucent.default': '#EDD44133',
        'surface.brand.secondary-2.translucent.low': '#EDD44114',
        'surface.brand.secondary-2.translucent.medium': '#EDD44166',
        'surface.brand.secondary-2.translucent.strong': '#EDD44199',
        'surface.brand.secondary-2.translucent.subtle': '#EDD4410A',
        'surface.brand.secondary-3.default': '#FFC471',
        'surface.brand.secondary-3.low': '#C64C08',
        'surface.brand.secondary-3.medium': '#FFDDA8',
        'surface.brand.secondary-3.strong': '#FFF8ED',
        'surface.brand.secondary-3.subtle': '#7E3410',
        'surface.brand.secondary-3.translucent.default': '#FFAD5433',
        'surface.brand.secondary-3.translucent.low': '#FFAD5414',
        'surface.brand.secondary-3.translucent.medium': '#FFAD5466',
        'surface.brand.secondary-3.translucent.strong': '#FFAD5499',
        'surface.brand.secondary-3.translucent.subtle': '#FFAD540A',
        'surface.brand.secondary-4.default': '#FFBABC',
        'surface.brand.secondary-4.low': '#9F6B6E',
        'surface.brand.secondary-4.medium': '#FFDDDD',
        'surface.brand.secondary-4.strong': '#FFF7F7',
        'surface.brand.secondary-4.subtle': '#3E2D30',
        'surface.brand.secondary-4.translucent.default': '#FFA9AB33',
        'surface.brand.secondary-4.translucent.low': '#FFA9AB14',
        'surface.brand.secondary-4.translucent.medium': '#FFA9AB66',
        'surface.brand.secondary-4.translucent.strong': '#FFA9AB99',
        'surface.brand.secondary-4.translucent.subtle': '#FFA9AB0A',
        'surface.brand.secondary-5.default': '#B3B8FF',
        'surface.brand.secondary-5.low': '#666AA0',
        'surface.brand.secondary-5.medium': '#D9DCFF',
        'surface.brand.secondary-5.strong': '#F6F7FF',
        'surface.brand.secondary-5.subtle': '#2B2C41',
        'surface.brand.secondary-5.translucent.default': '#A0A7FF33',
        'surface.brand.secondary-5.translucent.low': '#A0A7FF14',
        'surface.brand.secondary-5.translucent.medium': '#A0A7FF66',
        'surface.brand.secondary-5.translucent.strong': '#A0A7FF99',
        'surface.brand.secondary-5.translucent.subtle': '#A0A7FF0A',
        'surface.brand.strong': '#F5F6F8',
        'surface.brand.strong-alt': '#F2F7FC',
        'surface.brand.subtle': '#7F7C90',
        'surface.brand.subtle-alt': '#4467B1',
        'surface.brand.translucent.bold': '#7F7C9066',
        'surface.brand.translucent.bold-alt': '#7F7C9066',
        'surface.brand.translucent.default': '#7F7C9033',
        'surface.brand.translucent.strong': '#7F7C9066',
        'surface.brand.translucent.strong-alt': '#7F7C9066',
        'surface.brand.translucent.subtle': '#7F7C9014',
        'surface.default': '#282725',
        'surface.disabled': '#FDFDFC33',
        'surface.error.default': '#FD6C6F',
        'surface.error.low': '#BE171B',
        'surface.error.medium': '#FFC8C9',
        'surface.error.strong': '#FEF2F2',
        'surface.error.subtle': '#470809',
        'surface.error.translucent.default': '#F53E4266',
        'surface.error.translucent.strong': '#F53E4299',
        'surface.error.translucent.subtle': '#F53E4229',
        'surface.info.default': '#5C9CEF',
        'surface.info.low': '#255594',
        'surface.info.medium': '#ADCDF7',
        'surface.info.strong': '#EBF3FE',
        'surface.info.subtle': '#121A27',
        'surface.info.translucent.default': '#3383EB66',
        'surface.info.translucent.strong': '#3383EB99',
        'surface.info.translucent.subtle': '#3383EB29',
        'surface.interactive': '#81ADD9',
        'surface.inverse.default': '#FFFFFF',
        'surface.inverse.disabled': '#28272533',
        'surface.inverse.primary-neutral': '#9B988C',
        'surface.inverse.secondary-neutral': '#6B6861',
        'surface.inverse.selected': '#4467B1',
        'surface.inverse.selected-strong': '#FFFFFF',
        'surface.inverse.tertiary-neutral': '#3E3B38',
        'surface.overlay': '#28272566',
        'surface.primary': '#7F7C9014',
        'surface.primary-alt': '#242E47',
        'surface.primary-neutral': '#28272599',
        'surface.secondary': '#7F7C901F',
        'surface.secondary-alt': '#354973',
        'surface.secondary-neutral': '#FDFDFC14',
        'surface.selected': '#4467B1',
        'surface.selected-strong': '#81ADD9',
        'surface.strong-neutral': '#282725CC',
        'surface.success.default': '#96DF3C',
        'surface.success.low': '#457714',
        'surface.success.medium': '#CDF496',
        'surface.success.strong': '#F6FDE8',
        'surface.success.subtle': '#182C07',
        'surface.success.translucent.default': '#77C41E66',
        'surface.success.translucent.strong': '#77C41E99',
        'surface.success.translucent.subtle': '#77C41E29',
        'surface.tertiary': '#7F7C9029',
        'surface.tertiary-alt': '#3D5590',
        'surface.tertiary-neutral': '#FDFDFC29',
        'surface.translucent.default': '#2827250A',
        'surface.translucent.disabled': '#FDFDFC1F',
        'surface.translucent.primary': '#7F7C9014',
        'surface.translucent.primary-alt': '#7F7C9014',
        'surface.translucent.primary-neutral': '#FDFDFC14',
        'surface.translucent.secondary': '#7F7C9029',
        'surface.translucent.secondary-alt': '#7F7C9029',
        'surface.translucent.secondary-neutral': '#FDFDFC29',
        'surface.translucent.selected': '#7F7C9029',
        'surface.translucent.strong-neutral': '#FDFDFC66',
        'surface.translucent.tertiary': '#7F7C9066',
        'surface.translucent.tertiary-alt': '#7F7C9033',
        'surface.translucent.tertiary-neutral': '#FDFDFC33',
        'surface.warning.default': '#E8C427',
        'surface.warning.low': '#956213',
        'surface.warning.medium': '#F5EA93',
        'surface.warning.strong': '#FCFBEA',
        'surface.warning.subtle': '#3D220B',
        'surface.warning.translucent.default': '#D8AD1A66',
        'surface.warning.translucent.strong': '#D8AD1A99',
        'surface.warning.translucent.subtle': '#D8AD1A29',
        'text.brand': '#DFE0E6',
        'text.brand-alt': '#52525D',
        'text.disabled': '#FDFDFC66',
        'text.emphasized': '#81ADD9',
        'text.error': '#FD6C6F',
        'text.info': '#85B5F3',
        'text.interactive': '#81ADD9',
        'text.inverse.disabled': '#28272566',
        'text.inverse.emphasized': '#4467B1',
        'text.inverse.interactive': '#A0A0B4',
        'text.inverse.primary': '#282725',
        'text.inverse.secondary': '#6B6861',
        'text.primary': '#FFFFFF',
        'text.secondary': '#C6C3B9',
        'text.secondary-1.default': '#96DF3C',
        'text.secondary-1.low': '#457714',
        'text.secondary-1.medium': '#CDF496',
        'text.secondary-1.strong': '#F6FDE8',
        'text.secondary-1.subtle': '#325017',
        'text.secondary-2.default': '#F5EA93',
        'text.secondary-2.low': '#956213',
        'text.secondary-2.medium': '#E8C427',
        'text.secondary-2.strong': '#FCFBEA',
        'text.secondary-2.subtle': '#6A4019',
        'text.secondary-3.default': '#FFC471',
        'text.secondary-3.low': '#C64C08',
        'text.secondary-3.medium': '#FFDDA8',
        'text.secondary-3.strong': '#FFF8ED',
        'text.secondary-3.subtle': '#7E3410',
        'text.secondary-4.default': '#FFBABC',
        'text.secondary-4.low': '#9F6B6E',
        'text.secondary-4.medium': '#FFDDDD',
        'text.secondary-4.strong': '#FFF7F7',
        'text.secondary-4.subtle': '#3E2D30',
        'text.secondary-5.default': '#B3B8FF',
        'text.secondary-5.low': '#666AA0',
        'text.secondary-5.medium': '#D9DCFF',
        'text.secondary-5.strong': '#F6F7FF',
        'text.secondary-5.subtle': '#2B2C41',
        'text.selected': '#81ADD9',
        'text.success': '#96DF3C',
        'text.tertiary': '#6B6861',
        'text.warning': '#EDD441',
        white: '#FFFFFF',
        'white-label.footer.footer-bg': '#1F2635',
        'white-label.header.bg': '#161616',
        'white-label.header.on-header': '#FFFFFF',
        'white-label.headerSubtext': '#FFFFFF',
        'white-label.highlight': '#FFFFFF',
        'white-label.highlightText': '#FFFFFF',
        'white-label.notificationLogoBackground': '#FFFFFF',
        'white-label.publish-button.bg.header-bar': '#636271',
        'white-label.publish-button.bg.mobile-bottom-tab-bar': '#636271',
        'white-label.publish-button.icon.header-bar': '#FFFFFF',
        'white-label.publish-button.icon.mobile-bottom-tab-bar': '#FFFFFF',
        'white-label.publish-button.label.primary': '#FFFFFF',
        'white-label.splash': '#7F7C90',
        'white-label.theme.icon.on-brand-accent': '#FFFFFF',
        'white-label.theme.surface.accent': '#7F7C90',
        'white-label.theme.surface.primary': '#1F2635',
        'white-label.theme.text.on-brand-accent': '#FFFFFF',
      },
      responsive: {
        'border-width.bold': '4',
        'border-width.emphasized': '2',
        'border-width.standard': '1.5',
        'border-width.subtle': '1',
        'motion.distance.component-enter': '8',
        'motion.distance.feedback': '2',
        'motion.distance.overlay-enter': '16',
        'motion.distance.page-enter': '24',
        'motion.duration.component-transition': '[object Object]',
        'motion.duration.feedback': '[object Object]',
        'motion.duration.micro-transition': '[object Object]',
        'motion.duration.overlay-transition': '[object Object]',
        'motion.duration.page-transition': '[object Object]',
        'motion.duration.passive': '[object Object]',
        'motion.easing.continuous': '0,0,1,1',
        'motion.easing.emphasize': '0.05000000074505806,0.699999988079071,0.10000000149011612,1',
        'motion.easing.enter': '0,0,0,1',
        'motion.easing.exit': '0.4000000059604645,0,1,1',
        'motion.easing.move': '0.20000000298023224,0,0,1',
        'motion.scale.emphasize': '1.0199999809265137',
        'motion.scale.enter': '0.9599999785423279',
        'motion.scale.press': '0.9800000190734863',
        'motion.stagger.relaxed': '[object Object]',
        'motion.stagger.standard': '[object Object]',
        'motion.stagger.tight': '[object Object]',
        'radius.component.fields.input': '16',
        'radius.component.publish-button.button-radius': '8',
        'radius.full': '1000',
        'radius.lg': '16',
        'radius.md': '12',
        'radius.none': '0',
        'radius.sm': '8',
        'radius.xl': '24',
        'radius.xs': '4',
        'radius.xxl': '32',
        'radius.xxs': '2',
        'shadow.blur.lg': '24',
        'shadow.blur.md': '12',
        'shadow.blur.sm': '8',
        'shadow.blur.xl': '36',
        'shadow.blur.xs': '2',
        'shadow.offset-y.lg': '8',
        'shadow.offset-y.md': '4',
        'shadow.offset-y.sm': '2',
        'shadow.offset-y.xl': '16',
        'shadow.offset-y.xs': '1',
        'sizing.body.max-width': '1279',
        'sizing.body.min-width': '768',
        'sizing.component.button.height.large': '56',
        'sizing.component.button.height.large-icn-button': '48',
        'sizing.component.button.height.medium': '40',
        'sizing.component.button.height.small': '32',
        'sizing.component.header.max-width': '1279',
        'sizing.component.header.min-width': '768',
        'sizing.general.0': '0',
        'sizing.general.x0,25': '1',
        'sizing.general.x0,5': '2',
        'sizing.general.x1': '4',
        'sizing.general.x10': '40',
        'sizing.general.x100': '400',
        'sizing.general.x12': '48',
        'sizing.general.x120': '480',
        'sizing.general.x14': '56',
        'sizing.general.x140': '560',
        'sizing.general.x150': '600',
        'sizing.general.x16': '64',
        'sizing.general.x160': '640',
        'sizing.general.x18': '72',
        'sizing.general.x180': '720',
        'sizing.general.x2': '8',
        'sizing.general.x20': '80',
        'sizing.general.x200': '800',
        'sizing.general.x22': '88',
        'sizing.general.x24': '96',
        'sizing.general.x3': '12',
        'sizing.general.x30': '120',
        'sizing.general.x36': '144',
        'sizing.general.x4': '16',
        'sizing.general.x40': '160',
        'sizing.general.x5': '20',
        'sizing.general.x50': '200',
        'sizing.general.x6': '24',
        'sizing.general.x60': '240',
        'sizing.general.x7': '28',
        'sizing.general.x70': '280',
        'sizing.general.x8': '32',
        'sizing.general.x80': '320',
        'sizing.general.x90': '360',
        'sizing.icon.default': '24',
        'sizing.icon.lg': '32',
        'sizing.icon.s': '16',
        'sizing.icon.sm': '20',
        'sizing.icon.xl': '56',
        'sizing.icon.xs': '12',
        'spacing.general.0': '0',
        'spacing.general.x0,5': '2',
        'spacing.general.x1': '4',
        'spacing.general.x10': '40',
        'spacing.general.x12': '48',
        'spacing.general.x14': '56',
        'spacing.general.x16': '64',
        'spacing.general.x18': '72',
        'spacing.general.x2': '8',
        'spacing.general.x20': '80',
        'spacing.general.x22': '88',
        'spacing.general.x24': '96',
        'spacing.general.x3': '12',
        'spacing.general.x30': '120',
        'spacing.general.x36': '144',
        'spacing.general.x4': '16',
        'spacing.general.x5': '20',
        'spacing.general.x6': '24',
        'spacing.general.x7': '28',
        'spacing.general.x8': '32',
        'spacing.semantic.bottom-safe-zone': '36',
        'spacing.semantic.line-height-fix': '2',
        'spacing.semantic.page-margin': '32',
        'typography.font-size.body.base': '16',
        'typography.font-size.body.caption-base': '10',
        'typography.font-size.body.caption-large': '12',
        'typography.font-size.body.large': '18',
        'typography.font-size.body.small': '14',
        'typography.font-size.body.x-large': '20',
        'typography.font-size.body.x-small': '12',
        'typography.font-size.header.display-1': '48',
        'typography.font-size.header.display-2': '56',
        'typography.font-size.header.large': '40',
        'typography.font-size.header.medium': '32',
        'typography.font-size.header.small': '28',
        'typography.font-size.header.x-small': '24',
        'typography.font-size.link.link-base': '16',
        'typography.font-size.link.link-large': '20',
        'typography.font-size.link.link-small': '14',
        'typography.letter-spacing.body.base': '0',
        'typography.letter-spacing.body.caption': '0',
        'typography.letter-spacing.body.large': '0',
        'typography.letter-spacing.body.small': '0',
        'typography.letter-spacing.body.x-large': '0',
        'typography.letter-spacing.body.x-small': '0',
        'typography.letter-spacing.header.display-1': '0',
        'typography.letter-spacing.header.display-2': '0',
        'typography.letter-spacing.header.large': '0',
        'typography.letter-spacing.header.medium': '0',
        'typography.letter-spacing.header.small': '0',
        'typography.letter-spacing.header.x-small': '0',
      },
      styles: {
        header: {
          'display-2': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '56',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'display-1': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '48',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '40',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '40', letterSpacing: '0', lineHeight: 'normal' },
          },
          medium: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '32',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'medium-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '32', letterSpacing: '0', lineHeight: 'normal' },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '28',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '28', letterSpacing: '0', lineHeight: 'normal' },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '24',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '24', letterSpacing: '0', lineHeight: 'normal' },
          },
        },
        body: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontWeight: '700', fontSize: '18', letterSpacing: '0', lineHeight: '120%' },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontWeight: '400', fontSize: '14', letterSpacing: '0', lineHeight: '120%' },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        caption: {
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        paragraph: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        link: {
          'link-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
        },
      },
    },
    large: {
      brand: 'refrain',
      mode: 'dark',
      breakpoint: 'large',
      colors: {
        black: '#1F2635',
        'border.brand': '#DFE0E6',
        'border.brand-alt': '#354973',
        'border.disabled': '#28272529',
        'border.divider': '#FDFDFC33',
        'border.error': '#FD6C6F',
        'border.focused': '#81ADD9',
        'border.info': '#5C9CEF',
        'border.interactive': '#81ADD9',
        'border.inverse.disabled': '#28272566',
        'border.inverse.divider': '#2827251F',
        'border.inverse.interactive': '#A0A0B4',
        'border.inverse.primary': '#28272566',
        'border.inverse.secondary': '#28272529',
        'border.inverse.selected': '#7F7C90',
        'border.inverse.strong': '#1F2635',
        'border.primary': '#FDFDFC66',
        'border.secondary': '#FDFDFC29',
        'border.secondary-1.default': '#96DF3C',
        'border.secondary-1.strong': '#F6FDE8',
        'border.secondary-1.subtle': '#457714',
        'border.secondary-2.default': '#E8C427',
        'border.secondary-2.strong': '#FCFBEA',
        'border.secondary-2.subtle': '#956213',
        'border.secondary-3.default': '#FFAD54',
        'border.secondary-3.strong': '#FFF8ED',
        'border.secondary-3.subtle': '#C64C08',
        'border.secondary-4.default': '#FFBABC',
        'border.secondary-4.strong': '#FFF7F7',
        'border.secondary-4.subtle': '#9F6B6E',
        'border.secondary-5.default': '#B3B8FF',
        'border.secondary-5.low': '#666AA0',
        'border.secondary-5.medium': '#D9DCFF',
        'border.secondary-5.strong': '#F6F7FF',
        'border.secondary-5.subtle': '#2B2C41',
        'border.selected': '#4467B1',
        'border.strong': '#FFFFFF',
        'border.success': '#96DF3C',
        'border.warning': '#E8C427',
        'component.button.bg.hover': '#FDFDFC33',
        'component.button.bg.inverted': '#1F2635',
        'component.button.bg.pressed': '#28272566',
        'component.button.bg.primary': '#FFFFFF',
        'component.button.bg.secondary': '#DFE0E6',
        'component.button.bg.tertiary': '#3E3B38',
        'component.button.bg.transparent': '#FDFDFC66',
        'component.button.border.tertiary': '#FFFFFF',
        'component.button.icon.tertiary': '#DFE0E6',
        'component.button.label.tertiary': '#DFE0E6',
        'concept.ambassador.border': '#7C4D17',
        'concept.ambassador.icon': '#E8C427',
        'concept.ambassador.surface.default': '#E8C427',
        'concept.ambassador.surface.strong': '#F9F6C8',
        'concept.ambassador.surface.subtle': '#3D220B',
        'concept.ambassador.text': '#EDD441',
        'concept.exoneration.border': '#9D3D0F',
        'concept.exoneration.icon': '#FFAD54',
        'concept.exoneration.surface.default': '#B4B5C5',
        'concept.exoneration.surface.low': '#EDEEF2',
        'concept.exoneration.surface.medium': '#DFE0E6',
        'concept.exoneration.surface.strong': '#EDEEF2',
        'concept.exoneration.surface.subtle': '#303036',
        'concept.exoneration.text': '#FFC471',
        'concept.pension.border': '#3A5F15',
        'concept.pension.icon': '#96DF3C',
        'concept.pension.surface.default': '#5C9CEF',
        'concept.pension.surface.strong': '#D6E6FB',
        'concept.pension.surface.subtle': '#121A27',
        'concept.pension.text-on-dark': '#B3EC6A',
        'concept.pension.text-on-light': '#B3EC6A',
        'concept.plan.free.icon-on-surface': '#FFFFFF',
        'concept.plan.free.surface.default': '#5C9CEF',
        'concept.plan.free.surface.low': '#1C3C68',
        'concept.plan.free.surface.medium': '#ADCDF7',
        'concept.plan.free.surface.strong': '#D6E6FB',
        'concept.plan.free.surface.subtle': '#121A27',
        'concept.plan.free.text-on-surface': '#FFFFFF',
        'concept.plan.premium.accent': '#F5EA93',
        'concept.plan.premium.border': '#484B70',
        'concept.plan.premium.icon-on-surface': '#B3B8FF',
        'concept.plan.premium.surface.default': '#B3B8FF',
        'concept.plan.premium.surface.low': '#484B70',
        'concept.plan.premium.surface.medium': '#D9DCFF',
        'concept.plan.premium.surface.strong': '#ECEDFF',
        'concept.plan.premium.surface.subtle': '#1D1E28',
        'concept.plan.premium.text-on-surface': '#C6CAFF',
        'concept.trust-club.border': '#6E4C4E',
        'concept.trust-club.icon': '#FFBABC',
        'concept.trust-club.surface.default': '#FFBABC',
        'concept.trust-club.surface.strong': '#FFEEEE',
        'concept.trust-club.surface.subtle': '#261E20',
        'concept.trust-club.text-on-dark': '#FFCBCD',
        'concept.trust-club.text-on-light': '#FFCBCD',
        'gradient.bottom-tab-bar-end': '#161616E5',
        'gradient.bottom-tab-bar-start': '#16161600',
        'gradient.primary': '#16161600',
        'icon.brand': '#DFE0E6',
        'icon.brand-alt': '#52525D',
        'icon.disabled': '#FDFDFC66',
        'icon.emphasized': '#B4B5C5',
        'icon.error': '#FD6C6F',
        'icon.info': '#85B5F3',
        'icon.interactive': '#81ADD9',
        'icon.inverse.disabled': '#28272566',
        'icon.inverse.interactive': '#A0A0B4',
        'icon.inverse.on-selected': '#B4B5C5',
        'icon.inverse.primary': '#1F2635',
        'icon.inverse.secondary': '#6B6861',
        'icon.primary': '#FFFFFF',
        'icon.secondary': '#C6C3B9',
        'icon.secondary-1.default': '#96DF3C',
        'icon.secondary-1.low': '#457714',
        'icon.secondary-1.medium': '#CDF496',
        'icon.secondary-1.strong': '#F6FDE8',
        'icon.secondary-1.subtle': '#325017',
        'icon.secondary-2.default': '#E8C427',
        'icon.secondary-2.low': '#956213',
        'icon.secondary-2.medium': '#F5EA93',
        'icon.secondary-2.strong': '#FCFBEA',
        'icon.secondary-2.subtle': '#6A4019',
        'icon.secondary-3.default': '#FFAD54',
        'icon.secondary-3.low': '#C64C08',
        'icon.secondary-3.medium': '#FFDDA8',
        'icon.secondary-3.strong': '#FFF8ED',
        'icon.secondary-3.subtle': '#7E3410',
        'icon.secondary-4.default': '#FFBABC',
        'icon.secondary-4.low': '#9F6B6E',
        'icon.secondary-4.medium': '#FFDDDD',
        'icon.secondary-4.strong': '#FFF7F7',
        'icon.secondary-4.subtle': '#3E2D30',
        'icon.secondary-5.default': '#B3B8FF',
        'icon.secondary-5.low': '#666AA0',
        'icon.secondary-5.medium': '#D9DCFF',
        'icon.secondary-5.strong': '#F6F7FF',
        'icon.secondary-5.subtle': '#2B2C41',
        'icon.selected': '#81ADD9',
        'icon.success': '#96DF3C',
        'icon.tertiary': '#6B6861',
        'icon.warning': '#EDD441',
        page: '#161616',
        'shadow.inner': '#FDFDFC33',
        'shadow.lg': '#28272599',
        'shadow.md': '#28272566',
        'shadow.sm': '#28272533',
        'shadow.xl': '#282725CC',
        'shadow.xs': '#2827251F',
        'state-layer.hover': '#FDFDFC14',
        'state-layer.hover-alt': '#28272529',
        'state-layer.hover-brand': '#7F7C9029',
        'state-layer.hover-on-color': '#FDFDFC33',
        'state-layer.inverse.hover': '#28272514',
        'state-layer.inverse.hover-brand': '#7F7C9033',
        'state-layer.inverse.hover-on-color': '#FDFDFC33',
        'state-layer.inverse.press': '#28272529',
        'state-layer.inverse.press-brand': '#7F7C9066',
        'state-layer.inverse.press-on-color': '#28272566',
        'state-layer.press': '#FDFDFC29',
        'state-layer.press-alt': '#28272566',
        'state-layer.press-brand': '#7F7C9066',
        'state-layer.press-on-color': '#FDFDFC66',
        'surface.brand.bold': '#F5F6F8',
        'surface.brand.bold-alt': '#E2ECF7',
        'surface.brand.default': '#B4B5C5',
        'surface.brand.default-alt': '#81ADD9',
        'surface.brand.secondary-1.default': '#96DF3C',
        'surface.brand.secondary-1.low': '#457714',
        'surface.brand.secondary-1.medium': '#CDF496',
        'surface.brand.secondary-1.strong': '#F6FDE8',
        'surface.brand.secondary-1.subtle': '#325017',
        'surface.brand.secondary-1.translucent.default': '#CDF49633',
        'surface.brand.secondary-1.translucent.low': '#CDF49614',
        'surface.brand.secondary-1.translucent.medium': '#CDF49666',
        'surface.brand.secondary-1.translucent.strong': '#CDF49699',
        'surface.brand.secondary-1.translucent.subtle': '#CDF4960A',
        'surface.brand.secondary-2.default': '#F5EA93',
        'surface.brand.secondary-2.low': '#956213',
        'surface.brand.secondary-2.medium': '#E8C427',
        'surface.brand.secondary-2.strong': '#FCFBEA',
        'surface.brand.secondary-2.subtle': '#6A4019',
        'surface.brand.secondary-2.translucent.default': '#EDD44133',
        'surface.brand.secondary-2.translucent.low': '#EDD44114',
        'surface.brand.secondary-2.translucent.medium': '#EDD44166',
        'surface.brand.secondary-2.translucent.strong': '#EDD44199',
        'surface.brand.secondary-2.translucent.subtle': '#EDD4410A',
        'surface.brand.secondary-3.default': '#FFC471',
        'surface.brand.secondary-3.low': '#C64C08',
        'surface.brand.secondary-3.medium': '#FFDDA8',
        'surface.brand.secondary-3.strong': '#FFF8ED',
        'surface.brand.secondary-3.subtle': '#7E3410',
        'surface.brand.secondary-3.translucent.default': '#FFAD5433',
        'surface.brand.secondary-3.translucent.low': '#FFAD5414',
        'surface.brand.secondary-3.translucent.medium': '#FFAD5466',
        'surface.brand.secondary-3.translucent.strong': '#FFAD5499',
        'surface.brand.secondary-3.translucent.subtle': '#FFAD540A',
        'surface.brand.secondary-4.default': '#FFBABC',
        'surface.brand.secondary-4.low': '#9F6B6E',
        'surface.brand.secondary-4.medium': '#FFDDDD',
        'surface.brand.secondary-4.strong': '#FFF7F7',
        'surface.brand.secondary-4.subtle': '#3E2D30',
        'surface.brand.secondary-4.translucent.default': '#FFA9AB33',
        'surface.brand.secondary-4.translucent.low': '#FFA9AB14',
        'surface.brand.secondary-4.translucent.medium': '#FFA9AB66',
        'surface.brand.secondary-4.translucent.strong': '#FFA9AB99',
        'surface.brand.secondary-4.translucent.subtle': '#FFA9AB0A',
        'surface.brand.secondary-5.default': '#B3B8FF',
        'surface.brand.secondary-5.low': '#666AA0',
        'surface.brand.secondary-5.medium': '#D9DCFF',
        'surface.brand.secondary-5.strong': '#F6F7FF',
        'surface.brand.secondary-5.subtle': '#2B2C41',
        'surface.brand.secondary-5.translucent.default': '#A0A7FF33',
        'surface.brand.secondary-5.translucent.low': '#A0A7FF14',
        'surface.brand.secondary-5.translucent.medium': '#A0A7FF66',
        'surface.brand.secondary-5.translucent.strong': '#A0A7FF99',
        'surface.brand.secondary-5.translucent.subtle': '#A0A7FF0A',
        'surface.brand.strong': '#F5F6F8',
        'surface.brand.strong-alt': '#F2F7FC',
        'surface.brand.subtle': '#7F7C90',
        'surface.brand.subtle-alt': '#4467B1',
        'surface.brand.translucent.bold': '#7F7C9066',
        'surface.brand.translucent.bold-alt': '#7F7C9066',
        'surface.brand.translucent.default': '#7F7C9033',
        'surface.brand.translucent.strong': '#7F7C9066',
        'surface.brand.translucent.strong-alt': '#7F7C9066',
        'surface.brand.translucent.subtle': '#7F7C9014',
        'surface.default': '#282725',
        'surface.disabled': '#FDFDFC33',
        'surface.error.default': '#FD6C6F',
        'surface.error.low': '#BE171B',
        'surface.error.medium': '#FFC8C9',
        'surface.error.strong': '#FEF2F2',
        'surface.error.subtle': '#470809',
        'surface.error.translucent.default': '#F53E4266',
        'surface.error.translucent.strong': '#F53E4299',
        'surface.error.translucent.subtle': '#F53E4229',
        'surface.info.default': '#5C9CEF',
        'surface.info.low': '#255594',
        'surface.info.medium': '#ADCDF7',
        'surface.info.strong': '#EBF3FE',
        'surface.info.subtle': '#121A27',
        'surface.info.translucent.default': '#3383EB66',
        'surface.info.translucent.strong': '#3383EB99',
        'surface.info.translucent.subtle': '#3383EB29',
        'surface.interactive': '#81ADD9',
        'surface.inverse.default': '#FFFFFF',
        'surface.inverse.disabled': '#28272533',
        'surface.inverse.primary-neutral': '#9B988C',
        'surface.inverse.secondary-neutral': '#6B6861',
        'surface.inverse.selected': '#4467B1',
        'surface.inverse.selected-strong': '#FFFFFF',
        'surface.inverse.tertiary-neutral': '#3E3B38',
        'surface.overlay': '#28272566',
        'surface.primary': '#7F7C9014',
        'surface.primary-alt': '#242E47',
        'surface.primary-neutral': '#28272599',
        'surface.secondary': '#7F7C901F',
        'surface.secondary-alt': '#354973',
        'surface.secondary-neutral': '#FDFDFC14',
        'surface.selected': '#4467B1',
        'surface.selected-strong': '#81ADD9',
        'surface.strong-neutral': '#282725CC',
        'surface.success.default': '#96DF3C',
        'surface.success.low': '#457714',
        'surface.success.medium': '#CDF496',
        'surface.success.strong': '#F6FDE8',
        'surface.success.subtle': '#182C07',
        'surface.success.translucent.default': '#77C41E66',
        'surface.success.translucent.strong': '#77C41E99',
        'surface.success.translucent.subtle': '#77C41E29',
        'surface.tertiary': '#7F7C9029',
        'surface.tertiary-alt': '#3D5590',
        'surface.tertiary-neutral': '#FDFDFC29',
        'surface.translucent.default': '#2827250A',
        'surface.translucent.disabled': '#FDFDFC1F',
        'surface.translucent.primary': '#7F7C9014',
        'surface.translucent.primary-alt': '#7F7C9014',
        'surface.translucent.primary-neutral': '#FDFDFC14',
        'surface.translucent.secondary': '#7F7C9029',
        'surface.translucent.secondary-alt': '#7F7C9029',
        'surface.translucent.secondary-neutral': '#FDFDFC29',
        'surface.translucent.selected': '#7F7C9029',
        'surface.translucent.strong-neutral': '#FDFDFC66',
        'surface.translucent.tertiary': '#7F7C9066',
        'surface.translucent.tertiary-alt': '#7F7C9033',
        'surface.translucent.tertiary-neutral': '#FDFDFC33',
        'surface.warning.default': '#E8C427',
        'surface.warning.low': '#956213',
        'surface.warning.medium': '#F5EA93',
        'surface.warning.strong': '#FCFBEA',
        'surface.warning.subtle': '#3D220B',
        'surface.warning.translucent.default': '#D8AD1A66',
        'surface.warning.translucent.strong': '#D8AD1A99',
        'surface.warning.translucent.subtle': '#D8AD1A29',
        'text.brand': '#DFE0E6',
        'text.brand-alt': '#52525D',
        'text.disabled': '#FDFDFC66',
        'text.emphasized': '#81ADD9',
        'text.error': '#FD6C6F',
        'text.info': '#85B5F3',
        'text.interactive': '#81ADD9',
        'text.inverse.disabled': '#28272566',
        'text.inverse.emphasized': '#4467B1',
        'text.inverse.interactive': '#A0A0B4',
        'text.inverse.primary': '#282725',
        'text.inverse.secondary': '#6B6861',
        'text.primary': '#FFFFFF',
        'text.secondary': '#C6C3B9',
        'text.secondary-1.default': '#96DF3C',
        'text.secondary-1.low': '#457714',
        'text.secondary-1.medium': '#CDF496',
        'text.secondary-1.strong': '#F6FDE8',
        'text.secondary-1.subtle': '#325017',
        'text.secondary-2.default': '#F5EA93',
        'text.secondary-2.low': '#956213',
        'text.secondary-2.medium': '#E8C427',
        'text.secondary-2.strong': '#FCFBEA',
        'text.secondary-2.subtle': '#6A4019',
        'text.secondary-3.default': '#FFC471',
        'text.secondary-3.low': '#C64C08',
        'text.secondary-3.medium': '#FFDDA8',
        'text.secondary-3.strong': '#FFF8ED',
        'text.secondary-3.subtle': '#7E3410',
        'text.secondary-4.default': '#FFBABC',
        'text.secondary-4.low': '#9F6B6E',
        'text.secondary-4.medium': '#FFDDDD',
        'text.secondary-4.strong': '#FFF7F7',
        'text.secondary-4.subtle': '#3E2D30',
        'text.secondary-5.default': '#B3B8FF',
        'text.secondary-5.low': '#666AA0',
        'text.secondary-5.medium': '#D9DCFF',
        'text.secondary-5.strong': '#F6F7FF',
        'text.secondary-5.subtle': '#2B2C41',
        'text.selected': '#81ADD9',
        'text.success': '#96DF3C',
        'text.tertiary': '#6B6861',
        'text.warning': '#EDD441',
        white: '#FFFFFF',
        'white-label.footer.footer-bg': '#1F2635',
        'white-label.header.bg': '#161616',
        'white-label.header.on-header': '#FFFFFF',
        'white-label.headerSubtext': '#FFFFFF',
        'white-label.highlight': '#FFFFFF',
        'white-label.highlightText': '#FFFFFF',
        'white-label.notificationLogoBackground': '#FFFFFF',
        'white-label.publish-button.bg.header-bar': '#636271',
        'white-label.publish-button.bg.mobile-bottom-tab-bar': '#636271',
        'white-label.publish-button.icon.header-bar': '#FFFFFF',
        'white-label.publish-button.icon.mobile-bottom-tab-bar': '#FFFFFF',
        'white-label.publish-button.label.primary': '#FFFFFF',
        'white-label.splash': '#7F7C90',
        'white-label.theme.icon.on-brand-accent': '#FFFFFF',
        'white-label.theme.surface.accent': '#7F7C90',
        'white-label.theme.surface.primary': '#1F2635',
        'white-label.theme.text.on-brand-accent': '#FFFFFF',
      },
      responsive: {
        'border-width.bold': '4',
        'border-width.emphasized': '2',
        'border-width.standard': '1.5',
        'border-width.subtle': '1',
        'motion.distance.component-enter': '12',
        'motion.distance.feedback': '4',
        'motion.distance.overlay-enter': '24',
        'motion.distance.page-enter': '32',
        'motion.duration.component-transition': '[object Object]',
        'motion.duration.feedback': '[object Object]',
        'motion.duration.micro-transition': '[object Object]',
        'motion.duration.overlay-transition': '[object Object]',
        'motion.duration.page-transition': '[object Object]',
        'motion.duration.passive': '[object Object]',
        'motion.easing.continuous': '0,0,1,1',
        'motion.easing.emphasize': '0.05000000074505806,0.699999988079071,0.10000000149011612,1',
        'motion.easing.enter': '0,0,0,1',
        'motion.easing.exit': '0.4000000059604645,0,1,1',
        'motion.easing.move': '0.20000000298023224,0,0,1',
        'motion.scale.emphasize': '1.0199999809265137',
        'motion.scale.enter': '0.9599999785423279',
        'motion.scale.press': '0.9800000190734863',
        'motion.stagger.relaxed': '[object Object]',
        'motion.stagger.standard': '[object Object]',
        'motion.stagger.tight': '[object Object]',
        'radius.component.fields.input': '16',
        'radius.component.publish-button.button-radius': '8',
        'radius.full': '1000',
        'radius.lg': '16',
        'radius.md': '12',
        'radius.none': '0',
        'radius.sm': '8',
        'radius.xl': '24',
        'radius.xs': '4',
        'radius.xxl': '32',
        'radius.xxs': '2',
        'shadow.blur.lg': '32',
        'shadow.blur.md': '16',
        'shadow.blur.sm': '8',
        'shadow.blur.xl': '48',
        'shadow.blur.xs': '4',
        'shadow.offset-y.lg': '8',
        'shadow.offset-y.md': '4',
        'shadow.offset-y.sm': '2',
        'shadow.offset-y.xl': '16',
        'shadow.offset-y.xs': '1',
        'sizing.body.max-width': '1440',
        'sizing.body.min-width': '1280',
        'sizing.component.button.height.large': '56',
        'sizing.component.button.height.large-icn-button': '48',
        'sizing.component.button.height.medium': '40',
        'sizing.component.button.height.small': '32',
        'sizing.component.header.max-width': '1920',
        'sizing.component.header.min-width': '1280',
        'sizing.general.0': '0',
        'sizing.general.x0,25': '1',
        'sizing.general.x0,5': '2',
        'sizing.general.x1': '4',
        'sizing.general.x10': '40',
        'sizing.general.x100': '400',
        'sizing.general.x12': '48',
        'sizing.general.x120': '480',
        'sizing.general.x14': '56',
        'sizing.general.x140': '560',
        'sizing.general.x150': '600',
        'sizing.general.x16': '64',
        'sizing.general.x160': '640',
        'sizing.general.x18': '72',
        'sizing.general.x180': '720',
        'sizing.general.x2': '8',
        'sizing.general.x20': '80',
        'sizing.general.x200': '800',
        'sizing.general.x22': '88',
        'sizing.general.x24': '96',
        'sizing.general.x3': '12',
        'sizing.general.x30': '120',
        'sizing.general.x36': '144',
        'sizing.general.x4': '16',
        'sizing.general.x40': '160',
        'sizing.general.x5': '20',
        'sizing.general.x50': '200',
        'sizing.general.x6': '24',
        'sizing.general.x60': '240',
        'sizing.general.x7': '28',
        'sizing.general.x70': '280',
        'sizing.general.x8': '32',
        'sizing.general.x80': '320',
        'sizing.general.x90': '360',
        'sizing.icon.default': '24',
        'sizing.icon.lg': '32',
        'sizing.icon.s': '16',
        'sizing.icon.sm': '20',
        'sizing.icon.xl': '56',
        'sizing.icon.xs': '12',
        'spacing.general.0': '0',
        'spacing.general.x0,5': '2',
        'spacing.general.x1': '4',
        'spacing.general.x10': '40',
        'spacing.general.x12': '48',
        'spacing.general.x14': '56',
        'spacing.general.x16': '64',
        'spacing.general.x18': '72',
        'spacing.general.x2': '8',
        'spacing.general.x20': '80',
        'spacing.general.x22': '88',
        'spacing.general.x24': '96',
        'spacing.general.x3': '12',
        'spacing.general.x30': '120',
        'spacing.general.x36': '144',
        'spacing.general.x4': '16',
        'spacing.general.x5': '20',
        'spacing.general.x6': '24',
        'spacing.general.x7': '28',
        'spacing.general.x8': '32',
        'spacing.semantic.bottom-safe-zone': '36',
        'spacing.semantic.line-height-fix': '2',
        'spacing.semantic.page-margin': '48',
        'typography.font-size.body.base': '16',
        'typography.font-size.body.caption-base': '10',
        'typography.font-size.body.caption-large': '12',
        'typography.font-size.body.large': '18',
        'typography.font-size.body.small': '14',
        'typography.font-size.body.x-large': '20',
        'typography.font-size.body.x-small': '12',
        'typography.font-size.header.display-1': '56',
        'typography.font-size.header.display-2': '64',
        'typography.font-size.header.large': '48',
        'typography.font-size.header.medium': '40',
        'typography.font-size.header.small': '36',
        'typography.font-size.header.x-small': '32',
        'typography.font-size.link.link-base': '16',
        'typography.font-size.link.link-large': '20',
        'typography.font-size.link.link-small': '14',
        'typography.letter-spacing.body.base': '0',
        'typography.letter-spacing.body.caption': '0',
        'typography.letter-spacing.body.large': '0',
        'typography.letter-spacing.body.small': '0',
        'typography.letter-spacing.body.x-large': '0',
        'typography.letter-spacing.body.x-small': '0',
        'typography.letter-spacing.header.display-1': '0',
        'typography.letter-spacing.header.display-2': '0',
        'typography.letter-spacing.header.large': '0',
        'typography.letter-spacing.header.medium': '0',
        'typography.letter-spacing.header.small': '0',
        'typography.letter-spacing.header.x-small': '0',
      },
      styles: {
        header: {
          'display-2': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '64',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'display-1': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '56',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '48',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '48', letterSpacing: '0', lineHeight: 'normal' },
          },
          medium: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '40',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'medium-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '40', letterSpacing: '0', lineHeight: 'normal' },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '36',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '36', letterSpacing: '0', lineHeight: 'normal' },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '32',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '32', letterSpacing: '0', lineHeight: 'normal' },
          },
        },
        body: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontWeight: '700', fontSize: '18', letterSpacing: '0', lineHeight: '120%' },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontWeight: '400', fontSize: '14', letterSpacing: '0', lineHeight: '120%' },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        caption: {
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        paragraph: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        link: {
          'link-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
        },
      },
    },
  },
} as const;
